export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** Base64 encryped data */
  Base64: any
  /** DateTime */
  DateTime: any
  /** The `Decimal` scalar type represents a decimal number serialized as a string, e.g. "1.235". Its scale follows the unit it measures. */
  Decimal: string
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any
  /** The `UUID` scalar type represents UUID values as specified by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  MACAddress: string
  /** Primitive scalar: String | Int | Float | Boolean */
  Primitive: any
  URL: any
  /** The `UUID` scalar type represents UUID values as specified by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: any
  /** The `Upload` scalar type represents a file upload. */
  Upload: any
}

export type AcceptVisitorCheckInRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  visitorCheckInRequestId: Scalars['ID']
}

export type AcceptVisitorCheckInRequestPayload = MutationPayload & {
  __typename?: 'AcceptVisitorCheckInRequestPayload'
  clientMutationId?: Maybe<Scalars['String']>
  visitorCheckInRequest: VisitorCheckInRequest
}

export type AccessCode = Node & {
  __typename?: 'AccessCode'
  accessDateTimeRange?: Maybe<DateTimeRange>
  code: Scalars['String']
  databaseId: Scalars['Int']
  id: Scalars['ID']
  name?: Maybe<Scalars['String']>
  usageLimit?: Maybe<Scalars['Int']>
  users: AccessCodeUserConnection
  viewerCanRemove: Scalars['Boolean']
}

export type AccessCodeUsersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  nameOrEmail?: InputMaybe<Scalars['String']>
}

export type AccessCodeUserConnection = {
  __typename?: 'AccessCodeUserConnection'
  edges: Array<AccessCodeUserEdge>
  nodes: Array<User>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessCodeUserEdge = {
  __typename?: 'AccessCodeUserEdge'
  addedAt: Scalars['DateTime']
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: User
}

export type AccessCustomCredentials = Node & {
  __typename?: 'AccessCustomCredentials'
  databaseId: Scalars['Int']
  field: AccessCustomCredentialsField
  id: Scalars['ID']
  value: Scalars['String']
}

export type AccessCustomCredentialsField = Node & {
  __typename?: 'AccessCustomCredentialsField'
  description: Scalars['String']
  id: Scalars['ID']
  name: Scalars['String']
}

export type AccessLog = Node & {
  __typename?: 'AccessLog'
  bluetoothSignalLevel?: Maybe<BluetoothSignalLevel>
  databaseId: Scalars['Int']
  id: Scalars['ID']
  lock?: Maybe<Lock>
  lockAction?: Maybe<LockAction>
  status: AccessLogStatus
  timestamp: Scalars['DateTime']
  user: User
  /** @deprecated Please use `user` field. This field will be removed in the next version */
  userEmail?: Maybe<Scalars['String']>
}

export enum AccessLogStatus {
  FailureBluetoothDisabled = 'FAILURE_BLUETOOTH_DISABLED',
  FailureConnectionInterrupted = 'FAILURE_CONNECTION_INTERRUPTED',
  FailureInvalidConnectionResponse = 'FAILURE_INVALID_CONNECTION_RESPONSE',
  FailureNoCredentials = 'FAILURE_NO_CREDENTIALS',
  FailureNoTrueTime = 'FAILURE_NO_TRUE_TIME',
  FailureTimeout = 'FAILURE_TIMEOUT',
  FailureUnknown = 'FAILURE_UNKNOWN',
  Success = 'SUCCESS',
}

export type AccessProfile = Node & {
  __typename?: 'AccessProfile'
  accessCodes?: Maybe<AccessProfileAccessCodeConnection>
  accessCustomCredentialsFields?: Maybe<AccessProfileAccessCustomCredentialsFieldsConnection>
  /** @deprecated Please use `settings` field. This field will be removed in the next version */
  accessScheduleType?: Maybe<AccessScheduleType>
  /** @deprecated Please use `settings` field. This field will be removed in the next version */
  accessVEvent?: Maybe<Scalars['String']>
  accessZone?: Maybe<AccessZone>
  /** @deprecated Please use `settings` field. This field will be removed in the next version */
  addingUserAllowed: Scalars['Boolean']
  availableUsers: AccessProfileUserConnection
  databaseId: Scalars['Int']
  description?: Maybe<Scalars['String']>
  /** @deprecated Please use `settings` field. This field will be removed in the next version */
  granteeLimitPerUser?: Maybe<Scalars['Int']>
  id: Scalars['ID']
  locks: AccessProfileLockConnection
  name: Scalars['String']
  settings?: Maybe<AccessProfileSettings>
  /** @deprecated Please do not use this field. It will be removed in the next version. Use `availableUsers` field instead. */
  users?: Maybe<AccessProfileUserConnection>
  viewerCanAddAccessCode: Scalars['Boolean']
  viewerCanAddUser: Scalars['Boolean']
  viewerCanDelete: Scalars['Boolean']
  viewerCanGenerateReport: Scalars['Boolean']
  viewerCanSeeAccessCodes: Scalars['Boolean']
  viewerCanUpdate: Scalars['Boolean']
  viewerCanUpdateLocks: Scalars['Boolean']
  viewerGranteeAccessDateTimeRangeRequired: Scalars['Boolean']
}

export type AccessProfileAccessCodesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
}

export type AccessProfileAvailableUsersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  ids?: InputMaybe<Array<Scalars['ID']>>
  isAdded?: InputMaybe<Scalars['Boolean']>
  last?: InputMaybe<Scalars['Int']>
  nameOrEmail?: InputMaybe<Scalars['String']>
}

export type AccessProfileLocksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type AccessProfileUsersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  ids?: InputMaybe<Array<Scalars['ID']>>
  last?: InputMaybe<Scalars['Int']>
  nameOrEmail?: InputMaybe<Scalars['String']>
  present?: InputMaybe<Scalars['Boolean']>
}

export type AccessProfileAccessCodeConnection = {
  __typename?: 'AccessProfileAccessCodeConnection'
  edges: Array<AccessProfileAccessCodeEdge>
  nodes: Array<AccessCode>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessProfileAccessCodeEdge = {
  __typename?: 'AccessProfileAccessCodeEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: AccessCode
}

export type AccessProfileAccessCustomCredentialsFieldsConnection = {
  __typename?: 'AccessProfileAccessCustomCredentialsFieldsConnection'
  edges: Array<AccessProfileAccessCustomCredentialsFieldsEdge>
  nodes: Array<AccessCustomCredentialsField>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessProfileAccessCustomCredentialsFieldsEdge = {
  __typename?: 'AccessProfileAccessCustomCredentialsFieldsEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: AccessCustomCredentialsField
}

export type AccessProfileLockConnection = {
  __typename?: 'AccessProfileLockConnection'
  edges: Array<AccessProfileLockEdge>
  nodes: Array<Lock>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessProfileLockEdge = {
  __typename?: 'AccessProfileLockEdge'
  accessProfile: AccessProfile
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  lock: Lock
  node: Lock
  options: AccessProfileLockOptionConnection
}

export type AccessProfileLockEdgeOptionsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type AccessProfileLockOptionConnection = {
  __typename?: 'AccessProfileLockOptionConnection'
  edges: Array<AccessProfileLockOptionEdge>
  nodes: Array<LockOption>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessProfileLockOptionEdge = {
  __typename?: 'AccessProfileLockOptionEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: LockOption
}

export type AccessProfileMembership = Node & {
  __typename?: 'AccessProfileMembership'
  accessCustomCredentials?: Maybe<AccessProfileMembershipAccessCustomCredentialsConnection>
  /** @deprecated Please use `start` and `end` fields. This field will be removed in the next version */
  accessDateTimeRange?: Maybe<DateTimeRange>
  end?: Maybe<Scalars['DateTime']>
  id: Scalars['ID']
  issuedAt: Scalars['DateTime']
  issuer: AccessProfileMembershipIssuer
  start?: Maybe<Scalars['DateTime']>
  viewerCanCancel: Scalars['Boolean']
  visitorCode?: Maybe<Scalars['String']>
}

export type AccessProfileMembershipAccessCustomCredentialsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type AccessProfileMembershipAccessCustomCredentialsConnection = {
  __typename?: 'AccessProfileMembershipAccessCustomCredentialsConnection'
  edges: Array<AccessProfileMembershipAccessCustomCredentialsEdge>
  nodes: Array<AccessCustomCredentials>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessProfileMembershipAccessCustomCredentialsEdge = {
  __typename?: 'AccessProfileMembershipAccessCustomCredentialsEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: AccessCustomCredentials
}

export type AccessProfileMembershipConnection = {
  __typename?: 'AccessProfileMembershipConnection'
  edges: Array<AccessProfileMembershipEdge>
  nodes: Array<AccessProfileMembership>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessProfileMembershipEdge = {
  __typename?: 'AccessProfileMembershipEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: AccessProfileMembership
}

export type AccessProfileMembershipIssuer =
  | AccessCode
  | AccessProfileMembershipUserIssuer
  | VisitorCheckInRequest

export type AccessProfileMembershipUserIssuer = {
  __typename?: 'AccessProfileMembershipUserIssuer'
  email: Scalars['String']
}

export type AccessProfileSettings = {
  __typename?: 'AccessProfileSettings'
  accessScheduleType?: Maybe<AccessScheduleType>
  accessVEvent?: Maybe<Scalars['String']>
  addingGranteeAllowed: Scalars['Boolean']
  granteeAccessDateTimeRangeRequired?: Maybe<Scalars['Boolean']>
  granteeLimitPerUser?: Maybe<Scalars['Int']>
}

export type AccessProfileUserConnection = {
  __typename?: 'AccessProfileUserConnection'
  edges: Array<AccessProfileUserEdge>
  nodes: Array<User>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessProfileUserEdge = {
  __typename?: 'AccessProfileUserEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  externalSystemFields?: Maybe<UserExternalSystemFieldConnection>
  isAdded: Scalars['Boolean']
  memberships: AccessProfileMembershipConnection
  node: User
}

export type AccessProfileUserEdgeMembershipsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export enum AccessScheduleType {
  Invalid = 'INVALID',
  Unlimited = 'UNLIMITED',
  Vevent = 'VEVENT',
}

export type AccessZone = Node & {
  __typename?: 'AccessZone'
  accessProfiles: AccessZoneAccessProfileConnection
  admins?: Maybe<AccessZoneAdminConnection>
  databaseId: Scalars['Int']
  delegatedAccount?: Maybe<DelegatedAccount>
  id: Scalars['ID']
  locks: AccessZoneLockConnection
  name: Scalars['String']
  organization?: Maybe<Organization>
  resourceProfiles: AccessZoneResourceProfileConnection
  resources: AccessZoneResourceConnection
  users?: Maybe<AccessZoneUserConnection>
  viewerCanConnectDelegatedAccount: Scalars['Boolean']
  viewerCanDisconnectDelegatedAccount: Scalars['Boolean']
  viewerCanUpdate: Scalars['Boolean']
  viewerCanUpdateAdmins: Scalars['Boolean']
  viewerCanUpdateLocks: Scalars['Boolean']
}

export type AccessZoneAccessProfilesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
}

export type AccessZoneAdminsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  nameOrEmail?: InputMaybe<Scalars['String']>
}

export type AccessZoneLocksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type AccessZoneResourceProfilesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type AccessZoneResourcesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  locationIds?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  types?: InputMaybe<Array<ResourceType>>
}

export type AccessZoneUsersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  nameOrEmail?: InputMaybe<Scalars['String']>
}

export type AccessZoneAccessProfileConnection = {
  __typename?: 'AccessZoneAccessProfileConnection'
  edges: Array<AccessZoneAccessProfileEdge>
  nodes: Array<AccessProfile>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessZoneAccessProfileEdge = {
  __typename?: 'AccessZoneAccessProfileEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: AccessProfile
}

export type AccessZoneAdminConnection = {
  __typename?: 'AccessZoneAdminConnection'
  edges: Array<AccessZoneAdminEdge>
  nodes: Array<User>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessZoneAdminEdge = {
  __typename?: 'AccessZoneAdminEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: User
}

export type AccessZoneLockConnection = {
  __typename?: 'AccessZoneLockConnection'
  edges: Array<AccessZoneLockEdge>
  nodes: Array<Lock>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessZoneLockEdge = {
  __typename?: 'AccessZoneLockEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Lock
  options?: Maybe<AccessZoneLockOptionConnection>
}

export type AccessZoneLockEdgeOptionsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type AccessZoneLockOptionConnection = {
  __typename?: 'AccessZoneLockOptionConnection'
  edges: Array<AccessZoneLockOptionEdge>
  nodes: Array<LockOption>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessZoneLockOptionEdge = {
  __typename?: 'AccessZoneLockOptionEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: LockOption
}

export type AccessZoneResourceConnection = {
  __typename?: 'AccessZoneResourceConnection'
  edges: Array<AccessZoneResourceEdge>
  nodes: Array<Resource>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessZoneResourceEdge = {
  __typename?: 'AccessZoneResourceEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Resource
}

export type AccessZoneResourceProfileConnection = {
  __typename?: 'AccessZoneResourceProfileConnection'
  edges: Array<AccessZoneResourceProfileEdge>
  nodes: Array<ResourceProfile>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessZoneResourceProfileEdge = {
  __typename?: 'AccessZoneResourceProfileEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: ResourceProfile
}

export type AccessZoneUserConnection = {
  __typename?: 'AccessZoneUserConnection'
  edges: Array<AccessZoneUserEdge>
  nodes: Array<User>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type AccessZoneUserEdge = {
  __typename?: 'AccessZoneUserEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: User
}

export type AddAccessCodeInput = {
  accessDateTimeRange?: InputMaybe<DateTimeRangeInput>
  accessProfileId: Scalars['ID']
  clientMutationId?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  usageLimit?: InputMaybe<Scalars['Int']>
}

export type AddAccessCodePayload = {
  __typename?: 'AddAccessCodePayload'
  accessCode: AccessCode
  accessProfile: AccessProfile
  clientMutationId?: Maybe<Scalars['String']>
}

export type AddOrganizationAdminInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  organizationId: Scalars['ID']
  userId: Scalars['ID']
}

export type AddOrganizationAdminPayload = MutationPayload & {
  __typename?: 'AddOrganizationAdminPayload'
  clientMutationId?: Maybe<Scalars['String']>
}

export type AddReactionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  content: ReactionContent
  subjectId: Scalars['ID']
}

export type AddReactionPayload = MutationPayload & {
  __typename?: 'AddReactionPayload'
  clientMutationId?: Maybe<Scalars['String']>
  reaction: Reaction
  subject: Reactable
}

export type AddUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  email: Scalars['String']
  languageId?: InputMaybe<Scalars['ID']>
  name?: InputMaybe<Scalars['String']>
  /** Leave empty to add the user with a BLUE_BOLT account. Setting MICROSOFT requires the viewer to be a super admin, and fails with AUTH_PROVIDER_MISMATCH if the user already has another kind of account. */
  requestedSsoAuthProvider?: InputMaybe<SsoAuthProvider>
}

export type AddUserPayload = MutationPayload & {
  __typename?: 'AddUserPayload'
  clientMutationId?: Maybe<Scalars['String']>
  user: User
}

export type AddUserToAccessProfileCustomCredentialsInput = {
  accessCustomCredentialsFieldId: Scalars['ID']
  value: Scalars['String']
}

export type AddUserToAccessProfileInput = {
  accessDateTimeRange?: InputMaybe<DateTimeRangeInput>
  accessProfileId: Scalars['ID']
  clientMutationId?: InputMaybe<Scalars['String']>
  createAppAccount?: InputMaybe<Scalars['Boolean']>
  customCredentials?: InputMaybe<
    Array<AddUserToAccessProfileCustomCredentialsInput>
  >
  email?: InputMaybe<Scalars['String']>
  /** Can only be used together with `start`. Must be after `start`. */
  end?: InputMaybe<Scalars['DateTime']>
  generateVisitorCode?: InputMaybe<Scalars['Boolean']>
  languageId?: InputMaybe<Scalars['ID']>
  name?: InputMaybe<Scalars['String']>
  /** Leave empty to add the user with a BLUE_BOLT account. Requires `createAppAccount` to be explicitly `true`. Setting MICROSOFT requires the viewer to be an admin of the access profile, and fails with AUTH_PROVIDER_MISMATCH if the user already has another kind of account. */
  requestedSsoAuthProvider?: InputMaybe<SsoAuthProvider>
  sendVisitorCodeViaEmail?: InputMaybe<Scalars['Boolean']>
  /** Must be defined if `end` is defined. Cannot be used together with the deprecated `accessDateTimeRange`. */
  start?: InputMaybe<Scalars['DateTime']>
  userId?: InputMaybe<Scalars['ID']>
}

export type AddUserToAccessProfilePayload = {
  __typename?: 'AddUserToAccessProfilePayload'
  accessCustomCredentials: Array<AccessCustomCredentials>
  /** @deprecated Please use `start` and `end` fields. This field will be removed in the next version */
  accessDateTimeRange?: Maybe<DateTimeRange>
  accessProfile: AccessProfile
  clientMutationId?: Maybe<Scalars['String']>
  end?: Maybe<Scalars['DateTime']>
  start?: Maybe<Scalars['DateTime']>
  user: User
  visitorCode?: Maybe<Scalars['String']>
}

export type ApplyAccessCodeInput = {
  accessCode: Scalars['String']
  clientMutationId?: InputMaybe<Scalars['String']>
}

export type ApplyAccessCodePayload = {
  __typename?: 'ApplyAccessCodePayload'
  accessCode: Scalars['String']
  clientMutationId?: Maybe<Scalars['String']>
}

export type Battery = {
  __typename?: 'Battery'
  isCriticalLow: Scalars['Boolean']
  level?: Maybe<Scalars['Float']>
}

export type Billing = {
  __typename?: 'Billing'
  /** Amount due, in minor currency units (e.g. grosze). */
  amountDue: Scalars['Int']
  currency: Scalars['String']
  payments: BillingPaymentConnection
  /** Quantity due, in `unit`. */
  quantityDue: Scalars['Decimal']
  /** Quantity paid or granted for free, in `unit`. */
  quantityPaid: Scalars['Decimal']
  unit: BillingUnit
  /** Price of one `unit`, in minor currency units (e.g. grosze). */
  unitAmount: Scalars['Int']
}

export type BillingPaymentsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type BillingPaymentConnection = {
  __typename?: 'BillingPaymentConnection'
  edges: Array<BillingPaymentEdge>
  nodes: Array<Payment>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type BillingPaymentEdge = {
  __typename?: 'BillingPaymentEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Payment
}

export enum BillingUnit {
  Hour = 'HOUR',
}

export enum BluetoothSignalLevel {
  Level_1 = 'LEVEL_1',
  Level_2 = 'LEVEL_2',
  Level_3 = 'LEVEL_3',
  Level_4 = 'LEVEL_4',
  Level_5 = 'LEVEL_5',
}

export type BookResourceCustomCredentialsInput = {
  accessCustomCredentialsFieldId: Scalars['ID']
  value: Scalars['String']
}

export type BookResourceInput = {
  chargeHolder?: InputMaybe<Scalars['Boolean']>
  clientMutationId?: InputMaybe<Scalars['String']>
  createAppAccount?: InputMaybe<Scalars['Boolean']>
  creditAccountId?: InputMaybe<Scalars['ID']>
  customCredentials?: InputMaybe<Array<BookResourceCustomCredentialsInput>>
  end: Scalars['DateTime']
  generateVisitorCode?: InputMaybe<Scalars['Boolean']>
  holderEmail?: InputMaybe<Scalars['String']>
  holderId?: InputMaybe<Scalars['ID']>
  /** Leave empty to add the holder with a BLUE_BOLT account. Requires `createAppAccount` to be explicitly `true`, and cannot be used when booking for yourself. Setting MICROSOFT requires the viewer to be an admin of the resource, and fails with AUTH_PROVIDER_MISMATCH if the holder already has another kind of account. */
  holderRequestedSsoAuthProvider?: InputMaybe<SsoAuthProvider>
  languageId?: InputMaybe<Scalars['ID']>
  resourceId: Scalars['ID']
  sendVisitorCodeViaEmail?: InputMaybe<Scalars['Boolean']>
  start: Scalars['DateTime']
}

export type BookResourcePayload = MutationPayload & {
  __typename?: 'BookResourcePayload'
  booking: ResourceBooking
  clientMutationId?: Maybe<Scalars['String']>
  resource: Resource
}

export type BooleanSetting = {
  __typename?: 'BooleanSetting'
  value: Scalars['Boolean']
  viewerCanUpdate: Scalars['Boolean']
}

export type Building = Node & {
  __typename?: 'Building'
  databaseId: Scalars['Int']
  id: Scalars['ID']
  name: Scalars['String']
  url: Scalars['URL']
}

export type CancelAccessProfileMembership = {
  accessProfileMembershipId: Scalars['ID']
  clientMutationId?: InputMaybe<Scalars['String']>
}

export type CancelAccessProfileMembershipPayload = MutationPayload & {
  __typename?: 'CancelAccessProfileMembershipPayload'
  accessProfile: AccessProfile
  clientMutationId?: Maybe<Scalars['String']>
}

export type CancelResourceBookingInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  resourceBookingId: Scalars['ID']
}

export type CancelResourceBookingPayload = MutationPayload & {
  __typename?: 'CancelResourceBookingPayload'
  booking: ResourceBooking
  clientMutationId?: Maybe<Scalars['String']>
  resource: Resource
}

export type CancelResourceSharingInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  resourceId: Scalars['ID']
}

export type CancelResourceSharingPayload = MutationPayload & {
  __typename?: 'CancelResourceSharingPayload'
  clientMutationId?: Maybe<Scalars['String']>
  resource: Resource
}

export enum CardFormat {
  Hid_26BitH10301 = 'HID_26_BIT_H10301',
  Hid_26BitRaw = 'HID_26_BIT_RAW',
  Hid_32BitCustomWad3 = 'HID_32_BIT_CUSTOM_WAD3',
  Hid_35BitCorporate_1000 = 'HID_35_BIT_CORPORATE_1000',
  Hid_37BitH10304 = 'HID_37_BIT_H10304',
  RnmCustom_52Bit = 'RNM_CUSTOM_52_BIT',
  /** @deprecated Not used. */
  TrtnCustom_32Bit = 'TRTN_CUSTOM_32_BIT',
}

export type CardFormatValue = {
  __typename?: 'CardFormatValue'
  value: CardFormat
}

export type ConfirmResourceBookingInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  resourceBookingId: Scalars['ID']
}

export type ConfirmResourceBookingPayload = MutationPayload & {
  __typename?: 'ConfirmResourceBookingPayload'
  booking: ResourceBooking
  clientMutationId?: Maybe<Scalars['String']>
  resource: Resource
}

export type ConfirmResourceBookingWithCodeInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  code: Scalars['String']
}

export type ConfirmResourceBookingWithCodePayload = MutationPayload & {
  __typename?: 'ConfirmResourceBookingWithCodePayload'
  clientMutationId?: Maybe<Scalars['String']>
}

export type ConnectDelegatedAccountToAccessZoneInput = {
  accessZoneId: Scalars['ID']
  clientMutationId?: InputMaybe<Scalars['String']>
  credentials: Scalars['JSONObject']
  provider: DelegatedAccountProvider
}

export type ConnectDelegatedAccountToAccessZonePayload = MutationPayload & {
  __typename?: 'ConnectDelegatedAccountToAccessZonePayload'
  accessZone: AccessZone
  clientMutationId?: Maybe<Scalars['String']>
}

export type ConnectExternalCalendarToResourceInput = {
  calendarId: Scalars['String']
  clientMutationId?: InputMaybe<Scalars['String']>
  resourceId: Scalars['ID']
  syncMode: ExternalCalendarSyncMode
}

export type ConnectExternalCalendarToResourcePayload = MutationPayload & {
  __typename?: 'ConnectExternalCalendarToResourcePayload'
  clientMutationId?: Maybe<Scalars['String']>
  resource: Resource
}

export type CreateAccessProfileInput2 = {
  /** The VEvent component from RFC5545. The supported properties are RRULE, EXRULE, RDATE, EXDATE, DTSTART, DTEND and DURATION. Other properties are not supported. DURATION or DTEND is required. Please use UTC timezone for DTSTART, DTEND and UNTIL. */
  accessVEvent?: InputMaybe<Scalars['String']>
  accessZoneId: Scalars['ID']
  addingUserAllowed?: InputMaybe<Scalars['Boolean']>
  clientMutationId?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  /** Please do not use this field (it is ignored). It will be removed in the next version. Use `accessVEvent` field instead. */
  endAccessTime?: InputMaybe<Scalars['DateTime']>
  granteeAccessDateTimeRangeRequired?: InputMaybe<Scalars['Boolean']>
  granteeLimitPerUser?: InputMaybe<Scalars['Int']>
  locks: Array<CreateAccessProfileLockInput>
  name: Scalars['String']
  /** Please do not use this field (it is ignored). It will be removed in the next version. Use `accessVEvent` field instead. */
  startAccessTime?: InputMaybe<Scalars['DateTime']>
}

export type CreateAccessProfileLockInput = {
  lockId: Scalars['ID']
  optionIds?: InputMaybe<Array<Scalars['ID']>>
}

export type CreateAccessProfilePayload = {
  __typename?: 'CreateAccessProfilePayload'
  accessProfile: AccessProfile
  clientMutationId?: Maybe<Scalars['String']>
}

export type CreateAccessZoneInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  locks?: InputMaybe<Array<CreateAccessZoneLockInput>>
  name: Scalars['String']
  organizationId: Scalars['ID']
  userLimit?: InputMaybe<Scalars['Int']>
}

export type CreateAccessZoneLockInput = {
  lockId: Scalars['ID']
  optionIds: Array<Scalars['ID']>
}

export type CreateAccessZonePayload = MutationPayload & {
  __typename?: 'CreateAccessZonePayload'
  accessZone: AccessZone
  clientMutationId?: Maybe<Scalars['String']>
}

export type CreateLocationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
}

export type CreateLocationPayload = MutationPayload & {
  __typename?: 'CreateLocationPayload'
  clientMutationId?: Maybe<Scalars['String']>
  location: Location
}

export type CreateOrganizationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  name: Scalars['String']
}

export type CreateOrganizationPayload = MutationPayload & {
  __typename?: 'CreateOrganizationPayload'
  clientMutationId?: Maybe<Scalars['String']>
  organization: Organization
}

export type CreateResourceInput = {
  accessZoneId: Scalars['ID']
  attachmentIds?: InputMaybe<Array<Scalars['ID']>>
  /** The VEvent component from RFC5545. The supported properties are RRULE, EXRULE, RDATE, EXDATE, DTSTART, DTEND and DURATION. Other properties are not supported. DURATION or DTEND is required. Please use UTC timezone for DTSTART, DTEND and UNTIL. */
  bookingAvailabilityVEvent?: InputMaybe<Scalars['String']>
  bookingCancellationEndOffset?: InputMaybe<Scalars['String']>
  bookingConfirmationByHolderAllowed?: InputMaybe<Scalars['Boolean']>
  bookingConfirmationEndOffset?: InputMaybe<Scalars['String']>
  bookingConfirmationStartOffset?: InputMaybe<Scalars['String']>
  bookingConfirmationViaLockConnectionAllowed?: InputMaybe<Scalars['Boolean']>
  /** Default value = 0, min value = 0 */
  bookingUnitPrice?: InputMaybe<Scalars['Int']>
  clientMutationId?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  featuredImageId?: InputMaybe<Scalars['ID']>
  holderPublic?: InputMaybe<Scalars['Boolean']>
  locationId: Scalars['ID']
  /** Default value = 0 min, min value = 0 min, max value = 60 min */
  lockAccessEndOffsetForBooking?: InputMaybe<Scalars['Int']>
  /** Min value = -60 min, default value = 0 min, max value = 0 min */
  lockAccessStartOffsetForBooking?: InputMaybe<Scalars['Int']>
  /** Optional. Minimum value = 0, maximum value = 1000 */
  maxTimeSlotsBackwardForBooking?: InputMaybe<Scalars['Int']>
  /** Optional. Minimum value = 0, maximum value = 1000 */
  maxTimeSlotsBackwardForSharing?: InputMaybe<Scalars['Int']>
  /** Optional. Minimum value = 0, maximum value = 3000 */
  maxTimeSlotsForwardForBooking?: InputMaybe<Scalars['Int']>
  /** Optional. Minimum value = 0, maximum value = 3000 */
  maxTimeSlotsForwardForSharing?: InputMaybe<Scalars['Int']>
  /** Optional. Minimum value = 1, maximum value = 3000 */
  maxTimeSlotsPerBooking?: InputMaybe<Scalars['Int']>
  /** Optional. Minimum value = 1, maximum value = 3000 */
  maxTimeSlotsPerSharing?: InputMaybe<Scalars['Int']>
  /** Minimum value = 1, maximum value = 1000 */
  minTimeSlotsPerBooking?: InputMaybe<Scalars['Int']>
  /** Minimum value = 1, maximum value = 1000 */
  minTimeSlotsPerSharing?: InputMaybe<Scalars['Int']>
  multipleBookingsOfSameTypeAllowed?: InputMaybe<Scalars['Boolean']>
  name: Scalars['String']
  ownerId?: InputMaybe<Scalars['ID']>
  timeSlotLength: ResourceTimeSlotLength
  timezone: Scalars['String']
  translations?: InputMaybe<Array<CreateResourceTranslationInput>>
  type: ResourceType
}

export type CreateResourcePayload = MutationPayload & {
  __typename?: 'CreateResourcePayload'
  clientMutationId?: Maybe<Scalars['String']>
  resource: Resource
}

export type CreateResourceProfileInput = {
  accessZoneId: Scalars['ID']
  clientMutationId?: InputMaybe<Scalars['String']>
  creditDistributionType?: InputMaybe<CreditDistributionType>
  creditRenewalFrequency?: InputMaybe<CreditRenewalFrequency>
  credits?: InputMaybe<Scalars['Int']>
  name: Scalars['String']
}

export type CreateResourceProfilePayload = MutationPayload & {
  __typename?: 'CreateResourceProfilePayload'
  clientMutationId?: Maybe<Scalars['String']>
  resourceProfile: ResourceProfile
}

export type CreateResourceTranslatedValuesInput = {
  description?: InputMaybe<Scalars['String']>
  name: Scalars['String']
}

export type CreateResourceTranslationInput = {
  languageId: Scalars['ID']
  values: CreateResourceTranslatedValuesInput
}

export type CreditAccount = Node & {
  __typename?: 'CreditAccount'
  creditBalance: Scalars['Int']
  id: Scalars['ID']
}

export enum CreditDistributionType {
  PerUser = 'PER_USER',
  Shared = 'SHARED',
}

export enum CreditRenewalFrequency {
  MonthlyFirstDay = 'MONTHLY_FIRST_DAY',
  WeeklyFriday = 'WEEKLY_FRIDAY',
  WeeklyMonday = 'WEEKLY_MONDAY',
  WeeklySaturday = 'WEEKLY_SATURDAY',
  WeeklySunday = 'WEEKLY_SUNDAY',
  WeeklyThursday = 'WEEKLY_THURSDAY',
  WeeklyTuesday = 'WEEKLY_TUESDAY',
  WeeklyWednesday = 'WEEKLY_WEDNESDAY',
}

export type DateTimeRange = {
  __typename?: 'DateTimeRange'
  end: Scalars['DateTime']
  start: Scalars['DateTime']
}

export type DateTimeRangeInput = {
  end: Scalars['DateTime']
  start: Scalars['DateTime']
}

export type DelegatedAccount = Node & {
  __typename?: 'DelegatedAccount'
  email: Scalars['String']
  id: Scalars['ID']
  provider: DelegatedAccountProvider
  reconnectRequired: Scalars['Boolean']
}

export enum DelegatedAccountProvider {
  Google = 'GOOGLE',
}

export type DeleteAccessProfileInput = {
  accessProfileId: Scalars['ID']
  clientMutationId?: InputMaybe<Scalars['String']>
}

export type DeleteAccessProfilePayload = {
  __typename?: 'DeleteAccessProfilePayload'
  clientMutationId?: Maybe<Scalars['String']>
}

export type DeleteFilesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  fileIds: Array<Scalars['ID']>
}

export type DeleteFilesPayload = MutationPayload & {
  __typename?: 'DeleteFilesPayload'
  clientMutationId?: Maybe<Scalars['String']>
}

export type DeleteResourceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  resourceId: Scalars['ID']
}

export type DeleteResourcePayload = MutationPayload & {
  __typename?: 'DeleteResourcePayload'
  clientMutationId?: Maybe<Scalars['String']>
}

export type DeleteResourceProfileInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  resourceProfileId: Scalars['ID']
}

export type DeleteResourceProfilePayload = MutationPayload & {
  __typename?: 'DeleteResourceProfilePayload'
  clientMutationId?: Maybe<Scalars['String']>
}

export type DisconnectDelegatedAccountFromAccessZoneInput = {
  accessZoneId: Scalars['ID']
  clientMutationId?: InputMaybe<Scalars['String']>
}

export type DisconnectDelegatedAccountFromAccessZonePayload =
  MutationPayload & {
    __typename?: 'DisconnectDelegatedAccountFromAccessZonePayload'
    accessZone: AccessZone
    clientMutationId?: Maybe<Scalars['String']>
  }

export type DisconnectExternalCalendarFromResourceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  resourceId: Scalars['ID']
}

export type DisconnectExternalCalendarFromResourcePayload = MutationPayload & {
  __typename?: 'DisconnectExternalCalendarFromResourcePayload'
  clientMutationId?: Maybe<Scalars['String']>
  resource: Resource
}

export type ExternalCalendar = {
  __typename?: 'ExternalCalendar'
  delegatedAccountProvider: DelegatedAccountProvider
  id: Scalars['String']
  name: Scalars['String']
}

export type ExternalCalendarIntegration = {
  __typename?: 'ExternalCalendarIntegration'
  externalCalendar: ExternalCalendar
  syncMode: ExternalCalendarSyncMode
}

export enum ExternalCalendarSyncMode {
  Push = 'PUSH',
}

export type ExternalSystemField = Node & {
  __typename?: 'ExternalSystemField'
  dataType: ExternalSystemFieldDataType
  databaseId: Scalars['Int']
  id: Scalars['ID']
  regexPattern: Scalars['String']
  summary: Scalars['String']
  title: Scalars['String']
}

export enum ExternalSystemFieldDataType {
  CardFormat = 'CardFormat',
  Hexadecimal32 = 'Hexadecimal32',
  String = 'String',
  UInt8 = 'UInt8',
  UInt16 = 'UInt16',
  UInt32 = 'UInt32',
  ULong = 'ULong',
}

export type ExternalSystemFieldValue = CardFormatValue | IntValue | StringValue

export type Faq = Node & {
  __typename?: 'FAQ'
  databaseId: Scalars['Int']
  id: Scalars['ID']
  title: Scalars['String']
  url: Scalars['URL']
}

export type File = Node & {
  __typename?: 'File'
  databaseId: Scalars['Int']
  downloadUrl: Scalars['URL']
  id: Scalars['ID']
  mimeType: Scalars['String']
  name: Scalars['String']
}

export type FreeTimeVisitorCheckInBenefit = {
  __typename?: 'FreeTimeVisitorCheckInBenefit'
  minutes: Scalars['Int']
  type: VisitorCheckInBenefitType
}

export type GenerateAccessProfileTotalUniqueEntryDatesPerUserReportInput = {
  accessProfileId: Scalars['ID']
  from: Scalars['DateTime']
  to: Scalars['DateTime']
}

export type GenerateAccessProfileUniqueEntryDatesPerUserReportInput = {
  accessProfileId: Scalars['ID']
  from: Scalars['DateTime']
  to: Scalars['DateTime']
}

export type GenerateOrganizationUsersReportInput = {
  from?: InputMaybe<Scalars['DateTime']>
  includeAccessCodesForAnonymousUser?: Scalars['Boolean']
  includeExternalSystemFieldValues?: Scalars['Boolean']
  organizationId: Scalars['ID']
  to?: InputMaybe<Scalars['DateTime']>
}

export type GenerateReportInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
  oneOf: GenerateReportInputUnion
}

export type GenerateReportInputUnion = {
  accessProfileTotalUniqueEntryDatesPerUserReport?: InputMaybe<GenerateAccessProfileTotalUniqueEntryDatesPerUserReportInput>
  accessProfileUniqueEntryDatesPerUserReport?: InputMaybe<GenerateAccessProfileUniqueEntryDatesPerUserReportInput>
  organizationUsersReport?: InputMaybe<GenerateOrganizationUsersReportInput>
  resourceBookingsForAccessZoneReport?: InputMaybe<GenerateResourceBookingsForAccessZoneReportInput>
  resourceBookingsTotalDurationPerUserAndResourceForAccessZoneReportInput?: InputMaybe<GenerateResourceBookingsTotalDurationPerUserAndResourceForAccessZoneReportInput>
  resourceBookingsWithActivitiesForAccessZoneReport?: InputMaybe<GenerateResourceBookingsWithActivitiesForAccessZoneReportInput>
}

export type GenerateReportPayload = MutationPayload & {
  __typename?: 'GenerateReportPayload'
  clientMutationId?: Maybe<Scalars['String']>
  reportName: Scalars['String']
  reportUrl: Scalars['URL']
}

export type GenerateResourceBookingsForAccessZoneReportInput = {
  accessZoneId: Scalars['ID']
  confirmed?: InputMaybe<Scalars['Boolean']>
  from: Scalars['DateTime']
  to: Scalars['DateTime']
}

export type GenerateResourceBookingsTotalDurationPerUserAndResourceForAccessZoneReportInput =
  {
    accessZoneId: Scalars['ID']
    from: Scalars['DateTime']
    to: Scalars['DateTime']
  }

export type GenerateResourceBookingsWithActivitiesForAccessZoneReportInput = {
  accessZoneId: Scalars['ID']
  from: Scalars['DateTime']
  to: Scalars['DateTime']
}

export type GeoPoint = {
  __typename?: 'GeoPoint'
  latitude: Scalars['Float']
  longitude: Scalars['Float']
}

export type GeoPointInput = {
  latitude: Scalars['Float']
  longitude: Scalars['Float']
}

export type GrantVisitorCheckInBenefitInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  type: VisitorCheckInBenefitType
  visitorCheckInRequestId?: InputMaybe<Scalars['ID']>
}

export type GrantVisitorCheckInBenefitPayload = MutationPayload & {
  __typename?: 'GrantVisitorCheckInBenefitPayload'
  clientMutationId?: Maybe<Scalars['String']>
  visitorCheckInRequest: VisitorCheckInRequest
}

export type IntSetting = {
  __typename?: 'IntSetting'
  value: Scalars['Int']
  viewerCanUpdate: Scalars['Boolean']
}

export type IntValue = {
  __typename?: 'IntValue'
  value: Scalars['Int']
}

export type Language = Node & {
  __typename?: 'Language'
  id: Scalars['ID']
  name: Scalars['String']
}

export type LocalNetwork = Node & {
  __typename?: 'LocalNetwork'
  id: Scalars['ID']
  name: Scalars['String']
  organization: Organization
}

export type LocalNetworkHost = Node & {
  __typename?: 'LocalNetworkHost'
  category: LocalNetworkHostCategory
  id: Scalars['ID']
  ipAddress: Scalars['String']
  lastScan?: Maybe<Scalars['DateTime']>
  lastSeen?: Maybe<Scalars['DateTime']>
  name: Scalars['String']
  network: LocalNetwork
  ports: Array<LocalNetworkHostPort>
  status: LocalNetworkHostStatus
}

export type LocalNetworkHostCategory = Node & {
  __typename?: 'LocalNetworkHostCategory'
  id: Scalars['ID']
  name: Scalars['String']
}

export type LocalNetworkHostPort = {
  __typename?: 'LocalNetworkHostPort'
  lastScan?: Maybe<Scalars['DateTime']>
  lastSeen?: Maybe<Scalars['DateTime']>
  name: Scalars['String']
  status: LocalNetworkHostPortStatus
  value: Scalars['Int']
}

export enum LocalNetworkHostPortStatus {
  Error = 'ERROR',
  Ok = 'OK',
  Warning = 'WARNING',
}

export enum LocalNetworkHostStatus {
  Error = 'ERROR',
  Ok = 'OK',
  Warning = 'WARNING',
}

export type Location = Node & {
  __typename?: 'Location'
  databaseId: Scalars['Int']
  id: Scalars['ID']
  locks: LocationLockConnection
  name: Scalars['String']
  spaceplanUrl?: Maybe<Scalars['URL']>
}

export type LocationLocksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type LocationLockConnection = {
  __typename?: 'LocationLockConnection'
  edges: Array<LocationLockEdge>
  nodes: Array<Lock>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type LocationLockEdge = {
  __typename?: 'LocationLockEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Lock
}

export type Lock = Node & {
  __typename?: 'Lock'
  /** @deprecated Please use `node` field. This field will be removed in the next version */
  action?: Maybe<LockAction>
  actions: LockActionConnection
  /** @deprecated Please do not use this field. It will be removed in the next version. Use `autoConnectStatus` field instead. */
  autoConnectAllowed: Scalars['Boolean']
  /** @deprecated Please do not use this field. It will be removed in the next version. Use `autoConnectStatus` field instead. */
  autoConnectEnabledDefaultValue: Scalars['Boolean']
  autoConnectStatus: LockAutoConnectStatus
  battery?: Maybe<Battery>
  carSupported: Scalars['Boolean']
  databaseId: Scalars['Int']
  defaultAction?: Maybe<LockAction>
  /** @deprecated Please do not use this field. It will be removed in the next version. Use `settings.defaultDescription` field instead. */
  defaultDescription?: Maybe<Scalars['String']>
  /** @deprecated Please do not use this field. It will be removed in the next version. Use `settings.defaultName` field instead. */
  defaultName?: Maybe<Scalars['String']>
  description: Scalars['String']
  /** @deprecated Please use `node` field. This field will be removed in the next version */
  device?: Maybe<LockDevice>
  devices: LockDeviceConnection
  geoPoint?: Maybe<GeoPoint>
  icon: LockIcon
  id: Scalars['ID']
  location: Location
  name: Scalars['String']
  options: LockOptionConnection
  /** Available only in system admin mode. */
  organization?: Maybe<Organization>
  /** @deprecated Please do not use this field. It will be removed in the next version. Use `proximityNotificationStatus` field instead. */
  proximityNotificationEnabledDefaultValue: Scalars['Boolean']
  proximityNotificationStatus: LockProximityNotificationStatus
  /** @deprecated Please do not use this field. It will be removed in the next version. Use `proximityNotificationStatus` field instead. */
  proximityNotificationSupported: Scalars['Boolean']
  /** Available for lock organization admins and in the system admin mode. */
  settings?: Maybe<LockSettings>
  significantRangeSupported: Scalars['Boolean']
  /** @deprecated Please do not use this field. It will be removed in the next version. Use `settings.translations` field instead. */
  translations?: Maybe<Array<LockTranslation>>
  viewerCanUpdate?: Maybe<Scalars['Boolean']>
  welcomeNotificationSupported: Scalars['Boolean']
}

export type LockActionArgs = {
  id?: InputMaybe<Scalars['ID']>
}

export type LockDeviceArgs = {
  id: Scalars['ID']
}

export type LockAction = Node & {
  __typename?: 'LockAction'
  default: Scalars['Boolean']
  displayValue?: Maybe<Scalars['String']>
  icon: LockActionIcon
  id: Scalars['ID']
  lock: Lock
  proximityNotificationGroupKey?: Maybe<Scalars['String']>
  sortOrder: Scalars['Int']
  successMessage?: Maybe<Scalars['String']>
  title: LockActionTitle
}

export type LockActionConnection = {
  __typename?: 'LockActionConnection'
  edges: Array<LockActionEdge>
  nodes: Array<LockAction>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type LockActionEdge = {
  __typename?: 'LockActionEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: LockAction
}

export enum LockActionIcon {
  Authorize = 'AUTHORIZE',
  Close = 'CLOSE',
  Down = 'DOWN',
  Enter = 'ENTER',
  Exit = 'EXIT',
  Floor = 'FLOOR',
  Open = 'OPEN',
  OpenPermanently = 'OPEN_PERMANENTLY',
  Up = 'UP',
}

export enum LockActionTitle {
  Authorize = 'AUTHORIZE',
  Close = 'CLOSE',
  Down = 'DOWN',
  Enter = 'ENTER',
  Exit = 'EXIT',
  Floor = 'FLOOR',
  Open = 'OPEN',
  OpenPermanently = 'OPEN_PERMANENTLY',
  Up = 'UP',
}

export enum LockAutoConnectStatus {
  DefaultDisabled = 'DEFAULT_DISABLED',
  DefaultEnabled = 'DEFAULT_ENABLED',
  Disallowed = 'DISALLOWED',
}

export type LockAutoConnectStatusSetting = {
  __typename?: 'LockAutoConnectStatusSetting'
  value: LockAutoConnectStatus
  viewerCanUpdate: Scalars['Boolean']
}

export type LockDevice = Node & {
  __typename?: 'LockDevice'
  battery?: Maybe<Battery>
  bluetoothUUID?: Maybe<Scalars['UUID']>
  databaseId: Scalars['Int']
  firmwareReleasedAt: Scalars['DateTime']
  firmwareVersion: Scalars['String']
  firmwareVersionCode: Scalars['String']
  id: Scalars['ID']
  lock: Lock
  macAddress: Scalars['MACAddress']
  name: Scalars['String']
  proximityTapRssiThreshold?: Maybe<Scalars['Int']>
  scanningRssiThreshold?: Maybe<Scalars['Int']>
  settings?: Maybe<LockDeviceSettings>
  type: LockDeviceType
  viewerCanUpdate: Scalars['Boolean']
}

export type LockDeviceConnection = {
  __typename?: 'LockDeviceConnection'
  edges: Array<LockDeviceEdge>
  nodes: Array<LockDevice>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type LockDeviceEdge = {
  __typename?: 'LockDeviceEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: LockDevice
}

export type LockDeviceFirmware = Node & {
  __typename?: 'LockDeviceFirmware'
  id: Scalars['ID']
  name: Scalars['String']
  versionCode: Scalars['String']
}

/** Lock device settings available in the system admin mode only. */
export type LockDeviceSettings = {
  __typename?: 'LockDeviceSettings'
  androidProximityTapRssiThreshold?: Maybe<Scalars['Int']>
  androidScanningRssiThreshold?: Maybe<Scalars['Int']>
  bleConnectionPersistent: Scalars['Boolean']
  /** Lock device clock drift in minutes. */
  clockDrift: Scalars['Int']
  firmware: LockDeviceFirmware
  iOSProximityTapRssiThreshold?: Maybe<Scalars['Int']>
  iOSScanningRssiThreshold?: Maybe<Scalars['Int']>
  p256PublicKey?: Maybe<Scalars['Base64']>
}

export enum LockDeviceType {
  Dtx = 'DTX',
  Etx = 'ETX',
  Htx = 'HTX',
  Mtx = 'MTX',
  Rtx = 'RTX',
}

export enum LockIcon {
  Barrier = 'BARRIER',
  Door = 'DOOR',
  Garage = 'GARAGE',
  Gate = 'GATE',
  Handle = 'HANDLE',
  Lift = 'LIFT',
  Lock = 'LOCK',
  Speedgate = 'SPEEDGATE',
}

export type LockIconSetting = {
  __typename?: 'LockIconSetting'
  value: LockIcon
  viewerCanUpdate: Scalars['Boolean']
}

export type LockOption = Node & {
  __typename?: 'LockOption'
  databaseId: Scalars['Int']
  displayValue?: Maybe<Scalars['String']>
  icon: LockOptionIcon
  id: Scalars['ID']
  sortOrder: Scalars['Int']
  title: LockOptionTitle
}

export type LockOptionConnection = {
  __typename?: 'LockOptionConnection'
  edges: Array<LockOptionEdge>
  nodes: Array<LockOption>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type LockOptionEdge = {
  __typename?: 'LockOptionEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: LockOption
}

export enum LockOptionIcon {
  Close = 'CLOSE',
  Down = 'DOWN',
  Enter = 'ENTER',
  Exit = 'EXIT',
  Floor = 'FLOOR',
  Open = 'OPEN',
  OpenPermanently = 'OPEN_PERMANENTLY',
  Up = 'UP',
}

export enum LockOptionTitle {
  Close = 'CLOSE',
  Down = 'DOWN',
  Enter = 'ENTER',
  Exit = 'EXIT',
  Floor = 'FLOOR',
  Open = 'OPEN',
  OpenPermanently = 'OPEN_PERMANENTLY',
  Up = 'UP',
}

export enum LockProximityNotificationStatus {
  DefaultDisabled = 'DEFAULT_DISABLED',
  DefaultEnabled = 'DEFAULT_ENABLED',
  Disallowed = 'DISALLOWED',
}

export type LockProximityNotificationStatusSetting = {
  __typename?: 'LockProximityNotificationStatusSetting'
  value: LockProximityNotificationStatus
  viewerCanUpdate: Scalars['Boolean']
}

/** Raw lock settings for the edit form. A setting is null when the viewer is not allowed to read it. */
export type LockSettings = {
  __typename?: 'LockSettings'
  autoConnectStatus?: Maybe<LockAutoConnectStatusSetting>
  /** Unlike `Lock.carSupported`, it does not depend on the lock geo point. */
  carSupported?: Maybe<BooleanSetting>
  defaultDescription?: Maybe<StringSetting>
  defaultName?: Maybe<StringSetting>
  geoPoint?: Maybe<NullableGeoPointSetting>
  icon?: Maybe<LockIconSetting>
  /** Offline lifetime in seconds, 0 when offline access is not supported. */
  offlineLifetime?: Maybe<IntSetting>
  proximityNotificationStatus?: Maybe<LockProximityNotificationStatusSetting>
  significantRangeSupported?: Maybe<BooleanSetting>
  translations?: Maybe<LockTranslationsSetting>
  welcomeNotificationSupported?: Maybe<BooleanSetting>
}

export type LockTranslatedValues = {
  __typename?: 'LockTranslatedValues'
  description: Scalars['String']
  name: Scalars['String']
}

export type LockTranslatedValuesInput = {
  description?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
}

export type LockTranslation = {
  __typename?: 'LockTranslation'
  language: Language
  values?: Maybe<LockTranslatedValues>
}

export type LockTranslationInput = {
  languageId: Scalars['ID']
  values?: InputMaybe<LockTranslatedValuesInput>
}

export type LockTranslationsSetting = {
  __typename?: 'LockTranslationsSetting'
  value: Array<LockTranslation>
  viewerCanUpdate: Scalars['Boolean']
}

export type Message = Node &
  Reactable & {
    __typename?: 'Message'
    attachments: MessageAttachmentConnection
    category?: Maybe<MessageCategory>
    content: Scalars['String']
    createdAt: Scalars['DateTime']
    databaseId: Scalars['Int']
    expiresAt?: Maybe<Scalars['DateTime']>
    featuredImage?: Maybe<File>
    id: Scalars['ID']
    reactionGroups: Array<ReactionGroup>
    sender: Scalars['String']
    targets?: Maybe<MessageTargetConnection>
    title: Scalars['String']
    viewerCanReact: Scalars['Boolean']
    viewerIsSender: Scalars['Boolean']
  }

export type MessageAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type MessageReactionGroupsArgs = {
  includeEmptyGroups?: InputMaybe<Scalars['Boolean']>
}

export type MessageTargetsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type MessageAttachmentConnection = {
  __typename?: 'MessageAttachmentConnection'
  edges: Array<MessageAttachmentEdge>
  nodes: Array<File>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type MessageAttachmentEdge = {
  __typename?: 'MessageAttachmentEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: File
}

export type MessageCategory = Node & {
  __typename?: 'MessageCategory'
  databaseId: Scalars['Int']
  id: Scalars['ID']
  name: Scalars['String']
}

export type MessageTarget = AccessProfile | AccessZone | User

export type MessageTargetConnection = {
  __typename?: 'MessageTargetConnection'
  edges: Array<MessageTargetEdge>
  nodes: Array<MessageTarget>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type MessageTargetEdge = {
  __typename?: 'MessageTargetEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: MessageTarget
}

export type Mutation = {
  __typename?: 'Mutation'
  /** Error codes: VISITOR_CHECK_IN_REQUEST_NOT_FOUND, MUTATION_FAILED, VISITOR_CHECK_IN_REQUEST_ALREADY_ACCEPTED, VISITOR_CHECK_IN_REQUEST_ALREADY_REJECTED, VISITOR_CHECK_IN_REQUEST_ALREADY_EXPIRED */
  acceptVisitorCheckInRequest: AcceptVisitorCheckInRequestPayload
  addAccessCode: AddAccessCodePayload
  /** Error codes: UNAUTHORIZED, USER_NOT_FOUND, ORGANIZATION_ADMIN_ALREADY_EXISTS, MUTATION_FAILED */
  addOrganizationAdmin: AddOrganizationAdminPayload
  /** Error codes: SUBJECT_NOT_FOUND, MUTATION_FAILED */
  addReaction: AddReactionPayload
  /** Error codes: VIEWER_NOT_VERIFIED, USER_ALREADY_EXISTS, EMAIL_ADDRESS_NOT_AVAILABLE, AUTH_PROVIDER_MISMATCH, MUTATION_FAILED */
  addUser: AddUserPayload
  /** Error codes: VIEWER_NOT_VERIFIED, USER_ALREADY_EXISTS, ACCESS_PROFILE_NOT_FOUND, USER_NOT_FOUND, AUTH_PROVIDER_MISMATCH, MUTATION_FAILED, USER_LIMIT_EXCEEDED, USER_CANNOT_ADD_INSELF_TO_ACCESS_PROFILE, INVALID_CUSTOM_CREDENTIALS, BAD_USER_INPUT, ACCESS_DATE_TIME_RANGE_REQUIRED */
  addUserToAccessProfile: AddUserToAccessProfilePayload
  /** Error codes: INVALID_ACCESS_CODE, USAGE_LIMIT_EXCEEDED, MUTATION_FAILED */
  applyAccessCode: ApplyAccessCodePayload
  /** Error codes: RESOURCE_NOT_FOUND, USER_NOT_VERIFIED, HOLDER_NOT_FOUND, AUTH_PROVIDER_MISMATCH, BAD_USER_INPUT, NO_CREDITS, CREDIT_ACCOUNT_NOT_FOUND, BOOKING_FOR_OTHERS_NOT_ALLOWED, MUTATION_FAILED */
  bookResource: BookResourcePayload
  cancelAccessProfileMembership: CancelAccessProfileMembershipPayload
  /** Error codes: USER_NOT_VERIFIED, RESOURCE_BOOKING_NOT_FOUND, RESOURCE_BOOKING_CONFIRMED, RESOURCE_BOOKING_CANCELLATION_PERIOD_EXPIRED, MUTATION_FAILED */
  cancelResourceBooking: CancelResourceBookingPayload
  cancelResourceSharing: CancelResourceSharingPayload
  /** Error codes: USER_NOT_VERIFIED, RESOURCE_BOOKING_NOT_FOUND, RESOURCE_BOOKING_CONFIRMATION_NOT_AVAILABLE, MUTATION_FAILED */
  confirmResourceBooking: ConfirmResourceBookingPayload
  /** Error codes: RESOURCE_BOOKING_NOT_FOUND | MUTATION_FAILED */
  confirmResourceBookingWithCode: ConfirmResourceBookingWithCodePayload
  /** Error codes: VIEWER_NOT_VERIFIED, ACCESS_ZONE_NOT_FOUND, MUTATION_FAILED */
  connectDelegatedAccountToAccessZone: ConnectDelegatedAccountToAccessZonePayload
  /** Error codes: VIEWER_NOT_VERIFIED, RESOURCE_NOT_FOUND, EXTERNAL_CALENDAR_NOT_FOUND, DELEGATED_ACCOUNT_CREDENTIALS_EXPIRED, MUTATION_FAILED */
  connectExternalCalendarToResource: ConnectExternalCalendarToResourcePayload
  createAccessProfile2: CreateAccessProfilePayload
  createAccessZone: CreateAccessZonePayload
  /** Error codes: USER_NOT_VERIFIED */
  createLocation: CreateLocationPayload
  /** Error codes: UNAUTHORIZED, MUTATION_FAILED */
  createOrganization: CreateOrganizationPayload
  /** Error codes: USER_NOT_VERIFIED, ACCESS_ZONE_NOT_FOUND, LOCATION_NOT_FOUND, OWNER_NOT_FOUND, ATTACHMENTS_NOT_FOUND, FEATURED_IMAGE_NOT_FOUND, MUTATION_FAILED */
  createResource: CreateResourcePayload
  /** Error codes: USER_NOT_VERIFIED, ACCESS_ZONE_NOT_FOUND, MUTATION_FAILED */
  createResourceProfile: CreateResourceProfilePayload
  /** Error codes: USER_NOT_VERIFIED, ACCESS_PROFILE_NOT_FOUND, MUTATION_FAILED */
  deleteAccessProfile: DeleteAccessProfilePayload
  /** Error codes: USER_NOT_VERIFIED, FILE_NOT_FOUND, MUTATION_FAILED */
  deleteFiles: DeleteFilesPayload
  /** Error codes: USER_NOT_VERIFIED, RESOURCE_NOT_FOUND, MUTATION_FAILED */
  deleteResource: DeleteResourcePayload
  /** Error codes: USER_NOT_VERIFIED, RESOURCE_PROFILE_NOT_FOUND, MUTATION_FAILED */
  deleteResourceProfile: DeleteResourceProfilePayload
  /** Error codes: VIEWER_NOT_VERIFIED, ACCESS_ZONE_NOT_FOUND, MUTATION_FAILED */
  disconnectDelegatedAccountFromAccessZone: DisconnectDelegatedAccountFromAccessZonePayload
  /** Error codes: VIEWER_NOT_VERIFIED, RESOURCE_NOT_FOUND, MUTATION_FAILED */
  disconnectExternalCalendarFromResource: DisconnectExternalCalendarFromResourcePayload
  generateReport: GenerateReportPayload
  /** Error codes: VISITOR_CHECK_IN_REQUEST_NOT_FOUND, BENEFIT_ALREADY_GRANTED, BENEFIT_NOT_AVAILABLE, BAD_USER_INPUT, MUTATION_FAILED */
  grantVisitorCheckInBenefit: GrantVisitorCheckInBenefitPayload
  /** Error codes: VIEWER_NOT_VERIFIED, DELEGATED_ACCOUNT_NOT_FOUND, EMAIL_MISMATCH, MUTATION_FAILED */
  reconnectDelegatedAccount: ReconnectDelegatedAccountPayload
  /** Error codes: VISITOR_CHECK_IN_REQUEST_NOT_FOUND, VISITOR_CHECK_IN_REQUEST_ALREADY_ACCEPTED, VISITOR_CHECK_IN_REQUEST_ALREADY_REJECTED, VISITOR_CHECK_IN_REQUEST_ALREADY_EXPIRED, MUTATION_FAILED */
  rejectVisitorCheckInRequest: RejectVisitorCheckInRequestPayload
  removeAccessCode: RemoveAccessCodePayload
  /** Error codes: UNAUTHORIZED, ORGANIZATION_ADMIN_NOT_FOUND, MUTATION_FAILED */
  removeOrganizationAdmin: RemoveOrganizationAdminPayload
  /** Error codes: SUBJECT_NOT_FOUND, MUTATION_FAILED */
  removeReaction: RemoveReactionPayload
  /** Error codes: USER_NOT_VERIFIED, USER_NOT_FOUND, MUTATION_FAILED */
  removeUser: RemoveUserPayload
  /** Error codes: USER_NOT_VERIFIED, ACCESS_PROFILE_NOT_FOUND, USER_NOT_FOUND, MUTATION_FAILED */
  removeUserFromAccessProfile: RemoveUserFromAccessProfilePayload
  sendMessage: SendMessagePayload
  /** Error codes: VIEWER_NOT_VERIFIED, EXTERNAL_SYSTEM_FIELD_NOT_FOUND, BAD_USER_INPUT, MUTATION_FAILED */
  setUserExternalSystemFieldValue: SetUserExternalSystemFieldValuePayload
  shareResource: ShareResourcePayload
  /** Error codes: INVALID_ACCESS_CODE, USAGE_LIMIT_EXCEEDED, MUTATION_FAILED */
  signUpWithAccessCode: SignUpWithAccessCodePayload
  updateAccessProfile: UpdateAccessProfilePayload
  /** Error codes: USER_NOT_VERIFIED, ACCESS_ZONE_NOT_FOUND, MUTATION_FAILED */
  updateAccessZone: UpdateAccessZonePayload
  /** Error codes: USER_NOT_VERIFIED, ACCESS_ZONE_NOT_FOUND, USERS_NOT_FOUND, MUTATION_FAILED */
  updateAdminsInAccessZone: UpdateAdminsInAccessZonePayload
  /** Settings the viewer is allowed to update have `viewerCanUpdate` set in `Lock.settings`. Error codes: UNAUTHORIZED, USER_NOT_VERIFIED, LOCK_NOT_FOUND, LANGUAGE_NOT_FOUND, MISSING_TRANSLATED_VALUE, MUTATION_FAILED */
  updateLock: UpdateLockPayload
  /** Requires an active system admin mode. Error codes: UNAUTHORIZED, LOCK_DEVICE_NOT_FOUND, LOCK_DEVICE_FIRMWARE_NOT_FOUND, MUTATION_FAILED */
  updateLockDevice: UpdateLockDevicePayload
  /** Error codes: USER_NOT_VERIFIED, ACCESS_PROFILE_NOT_FOUND, LOCKS_NOT_FOUND, LOCK_OPTIONS_NOT_FOUND, MUTATION_FAILED */
  updateLocksInAccessProfile: UpdateLocksInAccessProfilePayload
  /** Error codes: USER_NOT_VERIFIED, ACCESS_ZONE_NOT_FOUND, LOCKS_NOT_FOUND, LOCK_OPTIONS_NOT_FOUND, MUTATION_FAILED */
  updateLocksInAccessZone: UpdateLocksInAccessZonePayload
  /** Error codes: USER_NOT_VERIFIED, RESOURCE_NOT_FOUND, LOCKS_NOT_FOUND, LOCK_OPTIONS_NOT_FOUND, MUTATION_FAILED */
  updateLocksInResource: UpdateLocksInResourcePayload
  /** Error codes: USER_NOT_VERIFIED, RESOURCE_NOT_FOUND, OWNER_NOT_FOUND, LOCATION_NOT_FOUND, ATTACHMENTS_NOT_FOUND, FEATURED_IMAGE_NOT_FOUND, MUTATION_FAILED */
  updateResource: UpdateResourcePayload
  /** Error codes: USER_NOT_VERIFIED, RESOURCE_PROFILE_NOT_FOUND | MUTATION_FAILED */
  updateResourceProfile: UpdateResourceProfilePayload
  /**  Error codes: USER_NOT_VERIFIED, RESOURCE_PROFILE_NOT_FOUND, USERS_NOT_FOUND, MUTATION_FAILED */
  updateResourceProfilesInUser: UpdateResourceProfilesInUserPayload
  /** Error codes: USER_NOT_VERIFIED, RESOURCE_PROFILE_NOT_FOUND, RESOURCES_NOT_FOUND, MUTATION_FAILED */
  updateResourcesInResourceProfile: UpdateResourcesInResourceProfilePayload
  /** Error codes: MUTATION_FAILED */
  updateUserPreferences: UpdateUserPreferencesPayload
  /** Error codes: USER_NOT_VERIFIED, RESOURCE_PROFILE_NOT_FOUND, USERS_NOT_FOUND, MUTATION_FAILED */
  updateUsersInResourceProfile: UpdateUsersInResourceProfilePayload
  /** Error codes: USER_NOT_VERIFIED, MIME_TYPE_DISALLOWED, MUTATION_FAILED */
  uploadFile: UploadFilePayload
}

export type MutationAcceptVisitorCheckInRequestArgs = {
  input: AcceptVisitorCheckInRequestInput
}

export type MutationAddAccessCodeArgs = {
  input: AddAccessCodeInput
}

export type MutationAddOrganizationAdminArgs = {
  input: AddOrganizationAdminInput
}

export type MutationAddReactionArgs = {
  input: AddReactionInput
}

export type MutationAddUserArgs = {
  input: AddUserInput
}

export type MutationAddUserToAccessProfileArgs = {
  input: AddUserToAccessProfileInput
}

export type MutationApplyAccessCodeArgs = {
  input: ApplyAccessCodeInput
}

export type MutationBookResourceArgs = {
  input: BookResourceInput
}

export type MutationCancelAccessProfileMembershipArgs = {
  input: CancelAccessProfileMembership
}

export type MutationCancelResourceBookingArgs = {
  input: CancelResourceBookingInput
}

export type MutationCancelResourceSharingArgs = {
  input: CancelResourceSharingInput
}

export type MutationConfirmResourceBookingArgs = {
  input: ConfirmResourceBookingInput
}

export type MutationConfirmResourceBookingWithCodeArgs = {
  input: ConfirmResourceBookingWithCodeInput
}

export type MutationConnectDelegatedAccountToAccessZoneArgs = {
  input: ConnectDelegatedAccountToAccessZoneInput
}

export type MutationConnectExternalCalendarToResourceArgs = {
  input: ConnectExternalCalendarToResourceInput
}

export type MutationCreateAccessProfile2Args = {
  input: CreateAccessProfileInput2
}

export type MutationCreateAccessZoneArgs = {
  input: CreateAccessZoneInput
}

export type MutationCreateLocationArgs = {
  input: CreateLocationInput
}

export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput
}

export type MutationCreateResourceArgs = {
  input: CreateResourceInput
}

export type MutationCreateResourceProfileArgs = {
  input: CreateResourceProfileInput
}

export type MutationDeleteAccessProfileArgs = {
  input: DeleteAccessProfileInput
}

export type MutationDeleteFilesArgs = {
  input: DeleteFilesInput
}

export type MutationDeleteResourceArgs = {
  input: DeleteResourceInput
}

export type MutationDeleteResourceProfileArgs = {
  input: DeleteResourceProfileInput
}

export type MutationDisconnectDelegatedAccountFromAccessZoneArgs = {
  input: DisconnectDelegatedAccountFromAccessZoneInput
}

export type MutationDisconnectExternalCalendarFromResourceArgs = {
  input: DisconnectExternalCalendarFromResourceInput
}

export type MutationGenerateReportArgs = {
  input: GenerateReportInput
}

export type MutationGrantVisitorCheckInBenefitArgs = {
  input: GrantVisitorCheckInBenefitInput
}

export type MutationReconnectDelegatedAccountArgs = {
  input: ReconnectDelegatedAccountInput
}

export type MutationRejectVisitorCheckInRequestArgs = {
  input: RejectVisitorCheckInRequestInput
}

export type MutationRemoveAccessCodeArgs = {
  input: RemoveAccessCodeInput
}

export type MutationRemoveOrganizationAdminArgs = {
  input: RemoveOrganizationAdminInput
}

export type MutationRemoveReactionArgs = {
  input: RemoveReactionInput
}

export type MutationRemoveUserArgs = {
  input: RemoveUserInput
}

export type MutationRemoveUserFromAccessProfileArgs = {
  input: RemoveUserFromAccessProfileInput
}

export type MutationSendMessageArgs = {
  input: SendMessageInput
}

export type MutationSetUserExternalSystemFieldValueArgs = {
  input: SetUserExternalSystemFieldValueInput
}

export type MutationShareResourceArgs = {
  input: ShareResourceInput
}

export type MutationSignUpWithAccessCodeArgs = {
  input: SignUpWithAccessCodeInput
}

export type MutationUpdateAccessProfileArgs = {
  input: UpdateAccessProfileInput
}

export type MutationUpdateAccessZoneArgs = {
  input: UpdateAccessZoneInput
}

export type MutationUpdateAdminsInAccessZoneArgs = {
  input: UpdateAdminsInAccessZoneInput
}

export type MutationUpdateLockArgs = {
  input: UpdateLockInput
}

export type MutationUpdateLockDeviceArgs = {
  input: UpdateLockDeviceInput
}

export type MutationUpdateLocksInAccessProfileArgs = {
  input: UpdateLocksInAccessProfileInput
}

export type MutationUpdateLocksInAccessZoneArgs = {
  input: UpdateLocksInAccessZoneInput
}

export type MutationUpdateLocksInResourceArgs = {
  input: UpdateLocksInResourceInput
}

export type MutationUpdateResourceArgs = {
  input: UpdateResourceInput
}

export type MutationUpdateResourceProfileArgs = {
  input: UpdateResourceProfileInput
}

export type MutationUpdateResourceProfilesInUserArgs = {
  input: UpdateResourceProfilesInUserInput
}

export type MutationUpdateResourcesInResourceProfileArgs = {
  input: UpdateResourcesInResourceProfileInput
}

export type MutationUpdateUserPreferencesArgs = {
  input: UpdateUserPreferencesInput
}

export type MutationUpdateUsersInResourceProfileArgs = {
  input: UpdateUsersInResourceProfileInput
}

export type MutationUploadFileArgs = {
  input: UploadFileInput
}

export type MutationPayload = {
  clientMutationId?: Maybe<Scalars['String']>
}

export type Node = {
  id: Scalars['ID']
}

export type NullableGeoPointSetting = {
  __typename?: 'NullableGeoPointSetting'
  value?: Maybe<GeoPoint>
  viewerCanUpdate: Scalars['Boolean']
}

export type Organization = Node & {
  __typename?: 'Organization'
  accessZones?: Maybe<OrganizationAccessZoneConnection>
  admins?: Maybe<OrganizationAdminConnection>
  databaseId: Scalars['Int']
  id: Scalars['ID']
  locks?: Maybe<OrganizationLockConnection>
  name: Scalars['String']
}

export type OrganizationAccessZonesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type OrganizationAdminsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  nameOrEmail?: InputMaybe<Scalars['String']>
}

export type OrganizationLocksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  locationName?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
}

export type OrganizationAccessZoneConnection = {
  __typename?: 'OrganizationAccessZoneConnection'
  edges: Array<OrganizationAccessZoneEdge>
  nodes: Array<AccessZone>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type OrganizationAccessZoneEdge = {
  __typename?: 'OrganizationAccessZoneEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: AccessZone
}

export type OrganizationAdminConnection = {
  __typename?: 'OrganizationAdminConnection'
  edges: Array<OrganizationAdminEdge>
  nodes: Array<User>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type OrganizationAdminEdge = {
  __typename?: 'OrganizationAdminEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: User
  viewerCanRemove: Scalars['Boolean']
}

export type OrganizationLockConnection = {
  __typename?: 'OrganizationLockConnection'
  edges: Array<OrganizationLockEdge>
  nodes: Array<Lock>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type OrganizationLockEdge = {
  __typename?: 'OrganizationLockEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Lock
  options?: Maybe<OrganizationLockOptionConnection>
}

export type OrganizationLockEdgeOptionsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type OrganizationLockOptionConnection = {
  __typename?: 'OrganizationLockOptionConnection'
  edges: Array<OrganizationLockOptionEdge>
  nodes: Array<LockOption>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type OrganizationLockOptionEdge = {
  __typename?: 'OrganizationLockOptionEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: LockOption
}

export type PageInfo = {
  __typename?: 'PageInfo'
  endCursor?: Maybe<Scalars['String']>
  hasNextPage?: Maybe<Scalars['Boolean']>
  hasPreviousPage?: Maybe<Scalars['Boolean']>
  startCursor?: Maybe<Scalars['String']>
}

export type Payment = Node & {
  __typename?: 'Payment'
  /** Amount, in minor currency units (e.g. grosze). */
  amount: Scalars['Int']
  currency: Scalars['String']
  id: Scalars['ID']
  paidAt?: Maybe<Scalars['DateTime']>
  payerEmail: Scalars['String']
  /** Quantity paid for, in the `unit` of its billing. */
  quantity: Scalars['Decimal']
  requestedAt: Scalars['DateTime']
  status: PaymentStatus
  transactionRef?: Maybe<Scalars['String']>
}

export enum PaymentStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Pending = 'PENDING',
}

export type Query = {
  __typename?: 'Query'
  languages: Array<Language>
  node?: Maybe<Node>
  timezones: Array<Scalars['String']>
  viewer: User
}

export type QueryNodeArgs = {
  id: Scalars['ID']
}

export type Reactable = {
  reactionGroups: Array<ReactionGroup>
  viewerCanReact: Scalars['Boolean']
}

export type ReactableReactionGroupsArgs = {
  includeEmptyGroups?: InputMaybe<Scalars['Boolean']>
}

export type Reaction = Node & {
  __typename?: 'Reaction'
  addedAt: Scalars['DateTime']
  content: ReactionContent
  databaseId: Scalars['Int']
  id: Scalars['ID']
}

export enum ReactionContent {
  ClappingHands = 'CLAPPING_HANDS',
  Heart = 'HEART',
  Neutral = 'NEUTRAL',
  ThumbsDown = 'THUMBS_DOWN',
  ThumbsUp = 'THUMBS_UP',
}

export type ReactionGroup = {
  __typename?: 'ReactionGroup'
  content: ReactionContent
  reactors: ReactorConnection
  sortOrder: Scalars['Int']
  subject: Reactable
  viewerHasReacted: Scalars['Boolean']
}

export type ReactorConnection = {
  __typename?: 'ReactorConnection'
  totalCount: Scalars['Int']
}

export type ReconnectDelegatedAccountInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  credentials: Scalars['JSONObject']
  delegatedAccountId: Scalars['ID']
}

export type ReconnectDelegatedAccountPayload = MutationPayload & {
  __typename?: 'ReconnectDelegatedAccountPayload'
  clientMutationId?: Maybe<Scalars['String']>
  delegatedAccount: DelegatedAccount
}

export type RejectVisitorCheckInRequestInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  visitorCheckInRequestId: Scalars['ID']
}

export type RejectVisitorCheckInRequestPayload = MutationPayload & {
  __typename?: 'RejectVisitorCheckInRequestPayload'
  clientMutationId?: Maybe<Scalars['String']>
  visitorCheckInRequest: VisitorCheckInRequest
}

export type RemoveAccessCodeInput = {
  accessCodeId: Scalars['ID']
  clientMutationId?: InputMaybe<Scalars['String']>
}

export type RemoveAccessCodePayload = {
  __typename?: 'RemoveAccessCodePayload'
  accessProfile: AccessProfile
  clientMutationId?: Maybe<Scalars['String']>
}

export type RemoveOrganizationAdminInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  organizationId: Scalars['ID']
  userId: Scalars['ID']
}

export type RemoveOrganizationAdminPayload = MutationPayload & {
  __typename?: 'RemoveOrganizationAdminPayload'
  clientMutationId?: Maybe<Scalars['String']>
}

export type RemoveReactionInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  subjectId: Scalars['ID']
}

export type RemoveReactionPayload = MutationPayload & {
  __typename?: 'RemoveReactionPayload'
  clientMutationId?: Maybe<Scalars['String']>
  subject: Reactable
}

export type RemoveUserFromAccessProfileInput = {
  accessProfileId: Scalars['ID']
  clientMutationId?: InputMaybe<Scalars['String']>
  userId: Scalars['ID']
}

export type RemoveUserFromAccessProfilePayload = {
  __typename?: 'RemoveUserFromAccessProfilePayload'
  accessProfile?: Maybe<AccessProfile>
  clientMutationId?: Maybe<Scalars['String']>
  user?: Maybe<User>
}

export type RemoveUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  userId: Scalars['ID']
}

export type RemoveUserPayload = {
  __typename?: 'RemoveUserPayload'
  clientMutationId?: Maybe<Scalars['String']>
}

export type Resource = Node & {
  __typename?: 'Resource'
  accessCustomCredentialsFields?: Maybe<ResourceAccessCustomCredentialsFieldConnection>
  accessZone?: Maybe<AccessZone>
  attachments: ResourceAttachmentConnection
  autoCreateAppAccountOnBooking?: Maybe<Scalars['Boolean']>
  availableBookingHolders: ResourceUserConnection
  availableExternalCalendars?: Maybe<Array<ExternalCalendar>>
  bookingConfirmationByHolderAllowed?: Maybe<Scalars['Boolean']>
  /** Duration in ISO8601 */
  bookingConfirmationEndOffset?: Maybe<Scalars['String']>
  bookingConfirmationRequired: Scalars['Boolean']
  /** Duration in ISO8601 */
  bookingConfirmationStartOffset?: Maybe<Scalars['String']>
  bookingConfirmationViaLockConnectionAllowed?: Maybe<Scalars['Boolean']>
  bookingUnitPrice: Scalars['Int']
  bookings: ResourceResourceBookingConnection
  databaseId: Scalars['Int']
  description?: Maybe<Scalars['String']>
  externalCalendarIntegration?: Maybe<ExternalCalendarIntegration>
  featuredImage?: Maybe<File>
  holderBookingPrice?: Maybe<Scalars['Int']>
  holderCreditAccounts?: Maybe<ResourceHolderCreditAccountConnection>
  holderPublic: Scalars['Boolean']
  id: Scalars['ID']
  /** @deprecated Please do not use this field. It will be removed in the next version */
  isAvailable: Scalars['Boolean']
  /** @deprecated Please do not use this field. It will be removed in the next version */
  isOccupied: Array<Scalars['Boolean']>
  location: Location
  lockAccessEndOffsetForBooking: Scalars['Int']
  lockAccessStartOffsetForBooking: Scalars['Int']
  locks?: Maybe<ResourceLockConnection>
  maxBookingEnd?: Maybe<Scalars['DateTime']>
  maxSharingEnd?: Maybe<Scalars['DateTime']>
  /** @deprecated Please use `settings` field. This field will be removed in the next version */
  maxTimeSlotsBackwardForBooking?: Maybe<Scalars['Int']>
  maxTimeSlotsBackwardForSharing?: Maybe<Scalars['Int']>
  /** @deprecated Please use `settings` field. This field will be removed in the next version */
  maxTimeSlotsForwardForBooking?: Maybe<Scalars['Int']>
  maxTimeSlotsForwardForSharing?: Maybe<Scalars['Int']>
  maxTimeSlotsPerBooking?: Maybe<Scalars['Int']>
  maxTimeSlotsPerSharing?: Maybe<Scalars['Int']>
  minBookingStart?: Maybe<Scalars['DateTime']>
  minSharingStart?: Maybe<Scalars['DateTime']>
  minTimeSlotsPerBooking: Scalars['Int']
  minTimeSlotsPerSharing: Scalars['Int']
  multipleBookingsOfSameTypeAllowed: Scalars['Boolean']
  name: Scalars['String']
  occupancy?: Maybe<Array<ResourceOccupancy>>
  owner?: Maybe<User>
  settings?: Maybe<ResourceSettings>
  sharings?: Maybe<ResourceResourceSharingConnection>
  spaceplanPoint?: Maybe<SpaceplanPoint>
  timeSlotLength: ResourceTimeSlotLength
  timezone: Scalars['String']
  type: ResourceType
  users: ResourceUserConnection
  viewerBookingOffTimeslots: Array<TimeSlot>
  viewerCanBook: Array<Scalars['Boolean']>
  viewerCanCancelSharing: Scalars['Boolean']
  viewerCanConnectExternalCalendar: Scalars['Boolean']
  viewerCanDelete: Scalars['Boolean']
  viewerCanDisconnectExternalCalendar: Scalars['Boolean']
  /** @deprecated Please use `availableBookingHolders` field. This field will be removed in the next version */
  viewerCanSelectBookingHolder: Scalars['Boolean']
  viewerCanShare: Scalars['Boolean']
  viewerCanUpdate: Scalars['Boolean']
  /** Reasons why the current viewer cannot book this resource. */
  viewerCannotBookReasons: Array<Array<ResourceCannotBookReason>>
  /** Reasons why the current viewer cannot share this resource. */
  viewerCannotShareReasons: Array<Array<ResourceCannotShareReason>>
  viewerIsOwner: Scalars['Boolean']
  viewerTopLevelRole: RoleInResource
}

export type ResourceAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type ResourceAvailableBookingHoldersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  nameOrEmail?: InputMaybe<Scalars['String']>
}

export type ResourceBookingsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  from?: InputMaybe<Scalars['DateTime']>
  last?: InputMaybe<Scalars['Int']>
  to?: InputMaybe<Scalars['DateTime']>
  viewerIsHolder?: InputMaybe<Scalars['Boolean']>
}

export type ResourceHolderBookingPriceArgs = {
  end: Scalars['DateTime']
  holderEmail?: InputMaybe<Scalars['String']>
  holderId?: InputMaybe<Scalars['ID']>
  start: Scalars['DateTime']
}

export type ResourceHolderCreditAccountsArgs = {
  holderEmail?: InputMaybe<Scalars['String']>
  holderId?: InputMaybe<Scalars['ID']>
}

export type ResourceIsAvailableArgs = {
  end: Scalars['DateTime']
  start: Scalars['DateTime']
}

export type ResourceIsOccupiedArgs = {
  timeSlots: Array<TimeSlotInput>
}

export type ResourceLocksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type ResourceMaxBookingEndArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type ResourceMaxSharingEndArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type ResourceMinBookingStartArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type ResourceMinSharingStartArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type ResourceOccupancyArgs = {
  end: Scalars['DateTime']
  start: Scalars['DateTime']
}

export type ResourceSharingsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type ResourceUsersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  nameOrEmail?: InputMaybe<Scalars['String']>
}

export type ResourceViewerBookingOffTimeslotsArgs = {
  end: Scalars['DateTime']
  start: Scalars['DateTime']
}

export type ResourceViewerCanBookArgs = {
  holderEmail?: InputMaybe<Scalars['String']>
  holderId?: InputMaybe<Scalars['ID']>
  timeSlots: Array<TimeSlotInput>
}

export type ResourceViewerCannotBookReasonsArgs = {
  holderEmail?: InputMaybe<Scalars['String']>
  holderId?: InputMaybe<Scalars['ID']>
  timeSlots: Array<TimeSlotInput>
}

export type ResourceViewerCannotShareReasonsArgs = {
  timeSlots: Array<TimeSlotInput>
}

export type ResourceAccessCustomCredentialsFieldConnection = {
  __typename?: 'ResourceAccessCustomCredentialsFieldConnection'
  edges: Array<ResourceAccessCustomCredentialsFieldEdge>
  nodes: Array<AccessCustomCredentialsField>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type ResourceAccessCustomCredentialsFieldEdge = {
  __typename?: 'ResourceAccessCustomCredentialsFieldEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  isRequiredForBooking: Scalars['Boolean']
  node: AccessCustomCredentialsField
}

export type ResourceAttachmentConnection = {
  __typename?: 'ResourceAttachmentConnection'
  edges: Array<ResourceAttachmentEdge>
  nodes: Array<File>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type ResourceAttachmentEdge = {
  __typename?: 'ResourceAttachmentEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: File
}

export type ResourceAvailabilitySchedule = {
  __typename?: 'ResourceAvailabilitySchedule'
  isValid: Scalars['Boolean']
  vEvent: Scalars['String']
}

export type ResourceBooking = Node & {
  __typename?: 'ResourceBooking'
  accessCustomCredentials?: Maybe<ResourceBookingAccessCustomCredentialsConnection>
  addToGoogleCalendarUrl?: Maybe<Scalars['URL']>
  addToOffice365CalendarUrl?: Maybe<Scalars['URL']>
  addToOffice365MobileCalendarUrl?: Maybe<Scalars['URL']>
  addToOutlookMobileUrl?: Maybe<Scalars['URL']>
  addToOutlookUrl?: Maybe<Scalars['URL']>
  billingDetails?: Maybe<ResourceBookingBillingsDetails>
  confirmationEnd?: Maybe<Scalars['DateTime']>
  confirmationStart?: Maybe<Scalars['DateTime']>
  databaseId: Scalars['Int']
  end: Scalars['DateTime']
  holder?: Maybe<User>
  icsUrl?: Maybe<Scalars['URL']>
  id: Scalars['ID']
  resource: Resource
  start: Scalars['DateTime']
  timeSlot: TimeSlot
  timezone: Scalars['String']
  viewerCanCancel: Scalars['Boolean']
  viewerConfirmationStatus?: Maybe<ResourceBookingViewerConfirmationStatus>
  visitorCode?: Maybe<Scalars['String']>
}

export type ResourceBookingAccessCustomCredentialsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type ResourceBookingConfirmationEndArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type ResourceBookingConfirmationStartArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type ResourceBookingEndArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type ResourceBookingStartArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type ResourceBookingAccessCustomCredentialsConnection = {
  __typename?: 'ResourceBookingAccessCustomCredentialsConnection'
  edges: Array<ResourceBookingAccessCustomCredentialsEdge>
  nodes: Array<AccessCustomCredentials>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type ResourceBookingAccessCustomCredentialsEdge = {
  __typename?: 'ResourceBookingAccessCustomCredentialsEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: AccessCustomCredentials
}

export type ResourceBookingBillingsDetails = {
  __typename?: 'ResourceBookingBillingsDetails'
  chargedAmount: Scalars['Int']
  totalPrice: Scalars['Int']
  unitPrice: Scalars['Int']
}

export enum ResourceBookingViewerConfirmationStatus {
  AdminOnly = 'ADMIN_ONLY',
  AvailableAfterStartTimeInApp = 'AVAILABLE_AFTER_START_TIME_IN_APP',
  AvailableAfterStartTimeInAppOrViaLockConnection = 'AVAILABLE_AFTER_START_TIME_IN_APP_OR_VIA_LOCK_CONNECTION',
  AvailableAfterStartTimeViaLockConnection = 'AVAILABLE_AFTER_START_TIME_VIA_LOCK_CONNECTION',
  Done = 'DONE',
  Expired = 'EXPIRED',
  NotRequired = 'NOT_REQUIRED',
  ReadyInApp = 'READY_IN_APP',
  ReadyInAppOrViaLockConnection = 'READY_IN_APP_OR_VIA_LOCK_CONNECTION',
  ReadyViaLockConnection = 'READY_VIA_LOCK_CONNECTION',
}

export enum ResourceCannotBookReason {
  BookingEndInvalid = 'BOOKING_END_INVALID',
  BookingEndTooLate = 'BOOKING_END_TOO_LATE',
  BookingForOthersNotAllowed = 'BOOKING_FOR_OTHERS_NOT_ALLOWED',
  BookingStartInvalid = 'BOOKING_START_INVALID',
  BookingStartTooEarly = 'BOOKING_START_TOO_EARLY',
  BookingTooLong = 'BOOKING_TOO_LONG',
  BookingTooShort = 'BOOKING_TOO_SHORT',
  NoCredits = 'NO_CREDITS',
  ResourceOccupied = 'RESOURCE_OCCUPIED',
  ResourceUnavailable = 'RESOURCE_UNAVAILABLE',
  TooManyBookingsOfSameType = 'TOO_MANY_BOOKINGS_OF_SAME_TYPE',
}

export enum ResourceCannotShareReason {
  NotOwner = 'NOT_OWNER',
  ResourceAlreadyShared = 'RESOURCE_ALREADY_SHARED',
  SharingEndInvalid = 'SHARING_END_INVALID',
  SharingEndTooLate = 'SHARING_END_TOO_LATE',
  SharingStartInvalid = 'SHARING_START_INVALID',
  SharingStartTooEarly = 'SHARING_START_TOO_EARLY',
  SharingTooLong = 'SHARING_TOO_LONG',
  SharingTooShort = 'SHARING_TOO_SHORT',
}

export type ResourceHolderCreditAccountConnection = {
  __typename?: 'ResourceHolderCreditAccountConnection'
  edges: Array<ResourceHolderCreditAccountEdge>
  nodes: Array<CreditAccount>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type ResourceHolderCreditAccountEdge = {
  __typename?: 'ResourceHolderCreditAccountEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: CreditAccount
}

export type ResourceLockConnection = {
  __typename?: 'ResourceLockConnection'
  edges: Array<ResourceLockEdge>
  nodes: Array<Lock>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type ResourceLockEdge = {
  __typename?: 'ResourceLockEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Lock
  options: ResourceLockOptionConnection
}

export type ResourceLockEdgeOptionsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type ResourceLockOptionConnection = {
  __typename?: 'ResourceLockOptionConnection'
  edges: Array<ResourceLockOptionEdge>
  nodes: Array<LockOption>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type ResourceLockOptionEdge = {
  __typename?: 'ResourceLockOptionEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: LockOption
}

export type ResourceOccupancy = {
  __typename?: 'ResourceOccupancy'
  reason?: Maybe<ResourceOccupancyReason>
  timeSlot: TimeSlot
}

export type ResourceOccupancyReason = ResourceBooking

export type ResourceProfile = Node & {
  __typename?: 'ResourceProfile'
  accessZone?: Maybe<AccessZone>
  creditDistributionType?: Maybe<CreditDistributionType>
  creditRenewalFrequency?: Maybe<CreditRenewalFrequency>
  credits?: Maybe<Scalars['Int']>
  databaseId: Scalars['Int']
  id: Scalars['ID']
  name: Scalars['String']
  resources?: Maybe<ResourceProfileResourceConnection>
  users?: Maybe<ResourceProfileUserConnection>
  viewerCanDelete: Scalars['Boolean']
  viewerCanUpdate: Scalars['Boolean']
}

export type ResourceProfileResourcesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type ResourceProfileUsersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  nameOrEmail?: InputMaybe<Scalars['String']>
}

export type ResourceProfileResourceConnection = {
  __typename?: 'ResourceProfileResourceConnection'
  edges: Array<ResourceProfileResourceEdge>
  nodes: Array<Resource>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type ResourceProfileResourceEdge = {
  __typename?: 'ResourceProfileResourceEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Resource
}

export type ResourceProfileUserConnection = {
  __typename?: 'ResourceProfileUserConnection'
  edges: Array<ResourceProfileUserEdge>
  nodes: Array<User>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type ResourceProfileUserEdge = {
  __typename?: 'ResourceProfileUserEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: User
}

export type ResourceResourceBookingConnection = {
  __typename?: 'ResourceResourceBookingConnection'
  edges: Array<ResourceResourceBookingEdge>
  nodes: Array<ResourceBooking>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type ResourceResourceBookingEdge = {
  __typename?: 'ResourceResourceBookingEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: ResourceBooking
}

export type ResourceResourceSharingConnection = {
  __typename?: 'ResourceResourceSharingConnection'
  edges: Array<ResourceResourceSharingEdge>
  nodes: Array<ResourceSharing>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type ResourceResourceSharingEdge = {
  __typename?: 'ResourceResourceSharingEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: ResourceSharing
}

export type ResourceSettings = {
  __typename?: 'ResourceSettings'
  bookingAvailabilitySchedule?: Maybe<ResourceAvailabilitySchedule>
  bookingCancellationEndOffset?: Maybe<Scalars['String']>
  defaultDescription?: Maybe<Scalars['String']>
  defaultName: Scalars['String']
  translations: Array<ResourceTranslation>
}

export type ResourceSharing = Node & {
  __typename?: 'ResourceSharing'
  end: Scalars['DateTime']
  id: Scalars['ID']
  resource: Resource
  start: Scalars['DateTime']
  timeSlot: TimeSlot
  timezone: Scalars['String']
}

export type ResourceSharingEndArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type ResourceSharingStartArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export enum ResourceTimeSlotLength {
  FifteenMinutes = 'FIFTEEN_MINUTES',
  OneDay = 'ONE_DAY',
  OneHour = 'ONE_HOUR',
  ThirtyMinutes = 'THIRTY_MINUTES',
  TwoHours = 'TWO_HOURS',
}

export type ResourceTranslatedValues = {
  __typename?: 'ResourceTranslatedValues'
  description?: Maybe<Scalars['String']>
  name: Scalars['String']
}

export type ResourceTranslation = {
  __typename?: 'ResourceTranslation'
  language: Language
  values?: Maybe<ResourceTranslatedValues>
}

export enum ResourceType {
  ConferenceRoom = 'CONFERENCE_ROOM',
  Desk = 'DESK',
  Other = 'OTHER',
  ParkingSpot = 'PARKING_SPOT',
  Sauna = 'SAUNA',
}

export type ResourceUserConnection = {
  __typename?: 'ResourceUserConnection'
  edges: Array<ResourceUserEdge>
  nodes: Array<User>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type ResourceUserEdge = {
  __typename?: 'ResourceUserEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: User
}

export enum RoleInAccessProfile {
  Admin = 'ADMIN',
  /** @deprecated Not used. */
  User = 'USER',
}

export enum RoleInLocation {
  Admin = 'ADMIN',
  User = 'USER',
}

export enum RoleInResource {
  Admin = 'ADMIN',
  Owner = 'OWNER',
  User = 'USER',
}

export type SendMessageInput = {
  attachmentIds?: InputMaybe<Array<Scalars['ID']>>
  categoryId?: InputMaybe<Scalars['ID']>
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Max 500 chars. */
  content: Scalars['String']
  expiresAt?: InputMaybe<Scalars['DateTime']>
  featuredImageId?: InputMaybe<Scalars['ID']>
  sendAsPushNotification?: InputMaybe<Scalars['Boolean']>
  /** Max 50 chars. */
  sender: Scalars['String']
  targetIds: Array<Scalars['ID']>
  /** Max 100 chars. */
  title: Scalars['String']
}

export type SendMessagePayload = MutationPayload & {
  __typename?: 'SendMessagePayload'
  clientMutationId?: Maybe<Scalars['String']>
  message: Message
}

export type SetUserExternalSystemFieldValueInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  fields: Array<UserExternalSystemFieldValueInput>
}

export type SetUserExternalSystemFieldValuePayload = MutationPayload & {
  __typename?: 'SetUserExternalSystemFieldValuePayload'
  clientMutationId?: Maybe<Scalars['String']>
}

export type ShareResourceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  end?: InputMaybe<Scalars['DateTime']>
  resourceId: Scalars['ID']
  start: Scalars['DateTime']
}

export type ShareResourcePayload = MutationPayload & {
  __typename?: 'ShareResourcePayload'
  clientMutationId?: Maybe<Scalars['String']>
  resource: Resource
}

export type SignUpWithAccessCodeInput = {
  accessCode: Scalars['String']
  clientMutationId?: InputMaybe<Scalars['String']>
}

export type SignUpWithAccessCodePayload = {
  __typename?: 'SignUpWithAccessCodePayload'
  accessCode: Scalars['String']
  clientMutationId?: Maybe<Scalars['String']>
  customToken: Scalars['String']
  /** @deprecated Please do not use this field. It will be removed in the next version */
  viewer: User
}

export type SpaceplanPoint = {
  __typename?: 'SpaceplanPoint'
  x: Scalars['Float']
  y: Scalars['Float']
}

export type SpaceplanPointInput = {
  x: Scalars['Float']
  y: Scalars['Float']
}

export enum SsoAuthProvider {
  Microsoft = 'MICROSOFT',
}

export type StringSetting = {
  __typename?: 'StringSetting'
  value: Scalars['String']
  viewerCanUpdate: Scalars['Boolean']
}

export type StringValue = {
  __typename?: 'StringValue'
  value: Scalars['String']
}

export type TimeSlot = {
  __typename?: 'TimeSlot'
  end: Scalars['DateTime']
  start: Scalars['DateTime']
  timezone: Scalars['String']
}

export type TimeSlotEndArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type TimeSlotStartArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type TimeSlotInput = {
  end: Scalars['DateTime']
  start: Scalars['DateTime']
}

export type UpdateAccessProfileInput = {
  accessProfileId: Scalars['ID']
  /** The VEvent component from RFC5545. The supported properties are RRULE, EXRULE, RDATE, EXDATE, DTSTART, DTEND and DURATION. Other properties are not supported. DURATION or DTEND is required. Please use UTC timezone for DTSTART, DTEND and UNTIL. */
  accessVEvent?: InputMaybe<Scalars['String']>
  addingUserAllowed?: InputMaybe<Scalars['Boolean']>
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Maximum length = 255 characters. */
  description?: InputMaybe<Scalars['String']>
  granteeAccessDateTimeRangeRequired?: InputMaybe<Scalars['Boolean']>
  granteeLimitPerUser?: InputMaybe<Scalars['Int']>
  /** Please use `updateLocksInAccessProfile` mutation. This field will be removed in the next version. */
  locks?: InputMaybe<Array<UpdateAccessProfileLockInput>>
  name?: InputMaybe<Scalars['String']>
}

export type UpdateAccessProfileLockInput = {
  lockId: Scalars['ID']
  optionIds: Array<Scalars['ID']>
}

export type UpdateAccessProfilePayload = MutationPayload & {
  __typename?: 'UpdateAccessProfilePayload'
  accessProfile: AccessProfile
  clientMutationId?: Maybe<Scalars['String']>
}

export type UpdateAccessZoneInput = {
  accessZoneId: Scalars['ID']
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Please use `updateLocksInAccessZone` mutation. This field will be removed in the next version. */
  locks?: InputMaybe<Array<UpdateAccessZoneLockInput>>
  name?: InputMaybe<Scalars['String']>
}

export type UpdateAccessZoneLockInput = {
  lockId: Scalars['ID']
  optionIds: Array<Scalars['ID']>
}

export type UpdateAccessZonePayload = MutationPayload & {
  __typename?: 'UpdateAccessZonePayload'
  accessZone: AccessZone
  clientMutationId?: Maybe<Scalars['String']>
}

export type UpdateAdminsInAccessZoneInput = {
  accessZoneId: Scalars['ID']
  clientMutationId?: InputMaybe<Scalars['String']>
  userIdsToAdd?: InputMaybe<Array<Scalars['ID']>>
  userIdsToRemove?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateAdminsInAccessZonePayload = MutationPayload & {
  __typename?: 'UpdateAdminsInAccessZonePayload'
  accessZone: AccessZone
  clientMutationId?: Maybe<Scalars['String']>
}

export type UpdateLockDeviceInput = {
  /** Send null to clear the threshold. */
  androidProximityTapRssiThreshold?: InputMaybe<Scalars['Int']>
  /** Send null to clear the threshold. */
  androidScanningRssiThreshold?: InputMaybe<Scalars['Int']>
  bleConnectionPersistent?: InputMaybe<Scalars['Boolean']>
  clientMutationId?: InputMaybe<Scalars['String']>
  /** Lock device clock drift in minutes (-1440 to 1440). */
  clockDrift?: InputMaybe<Scalars['Int']>
  /** Firmware the lock device is running. */
  firmwareId?: InputMaybe<Scalars['ID']>
  /** Send null to clear the threshold. */
  iOSProximityTapRssiThreshold?: InputMaybe<Scalars['Int']>
  /** Send null to clear the threshold. */
  iOSScanningRssiThreshold?: InputMaybe<Scalars['Int']>
  lockDeviceId: Scalars['ID']
  /** Uncompressed P-256 public key (65 bytes, 0x04 prefixed). */
  p256PublicKey?: InputMaybe<Scalars['Base64']>
}

export type UpdateLockDevicePayload = MutationPayload & {
  __typename?: 'UpdateLockDevicePayload'
  clientMutationId?: Maybe<Scalars['String']>
  lockDevice: LockDevice
}

export type UpdateLockInput = {
  autoConnectStatus?: InputMaybe<LockAutoConnectStatus>
  carSupported?: InputMaybe<Scalars['Boolean']>
  clientMutationId?: InputMaybe<Scalars['String']>
  defaultDescription?: InputMaybe<Scalars['String']>
  defaultName?: InputMaybe<Scalars['String']>
  geoPoint?: InputMaybe<GeoPointInput>
  icon?: InputMaybe<LockIcon>
  lockId: Scalars['ID']
  /** Offline lifetime in seconds, 0 disables offline access. */
  offlineLifetime?: InputMaybe<Scalars['Int']>
  proximityNotificationStatus?: InputMaybe<LockProximityNotificationStatus>
  significantRangeSupported?: InputMaybe<Scalars['Boolean']>
  /** Null value not allowed. Send an empty array to clear all translations. */
  translations?: InputMaybe<Array<LockTranslationInput>>
  welcomeNotificationSupported?: InputMaybe<Scalars['Boolean']>
}

export type UpdateLockPayload = MutationPayload & {
  __typename?: 'UpdateLockPayload'
  clientMutationId?: Maybe<Scalars['String']>
  lock: Lock
}

export type UpdateLocksInAccessProfileInput = {
  accessProfileId: Scalars['ID']
  clientMutationId?: InputMaybe<Scalars['String']>
  locksToAdd?: InputMaybe<Array<UpdateLocksInAccessProfileLockInput>>
  locksToRemove?: InputMaybe<Array<UpdateLocksInAccessProfileLockInput>>
}

export type UpdateLocksInAccessProfileLockInput = {
  lockId: Scalars['ID']
  optionIds?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateLocksInAccessProfilePayload = MutationPayload & {
  __typename?: 'UpdateLocksInAccessProfilePayload'
  accessProfile: AccessProfile
  clientMutationId?: Maybe<Scalars['String']>
}

export type UpdateLocksInAccessZoneInput = {
  accessZoneId: Scalars['ID']
  clientMutationId?: InputMaybe<Scalars['String']>
  locksToAdd?: InputMaybe<Array<UpdateLocksInAccessZoneLockInput>>
  locksToRemove?: InputMaybe<Array<UpdateLocksInAccessZoneLockInput>>
}

export type UpdateLocksInAccessZoneLockInput = {
  lockId: Scalars['ID']
  optionIds?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateLocksInAccessZonePayload = MutationPayload & {
  __typename?: 'UpdateLocksInAccessZonePayload'
  accessZone: AccessZone
  clientMutationId?: Maybe<Scalars['String']>
}

export type UpdateLocksInResourceInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  locksToAdd?: InputMaybe<Array<UpdateLocksInResourceLockInput>>
  locksToRemove?: InputMaybe<Array<UpdateLocksInResourceLockInput>>
  resourceId: Scalars['ID']
}

export type UpdateLocksInResourceLockInput = {
  lockId: Scalars['ID']
  optionIds?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateLocksInResourcePayload = MutationPayload & {
  __typename?: 'UpdateLocksInResourcePayload'
  clientMutationId?: Maybe<Scalars['String']>
  resource: Resource
}

export type UpdateResourceInput = {
  attachmentIds?: InputMaybe<Array<Scalars['ID']>>
  /** The VEvent component from RFC5545. The supported properties are RRULE, EXRULE, RDATE, EXDATE, DTSTART, DTEND and DURATION. Other properties are not supported. DURATION or DTEND is required. Please use UTC timezone for DTSTART, DTEND and UNTIL. */
  bookingAvailabilityVEvent?: InputMaybe<Scalars['String']>
  bookingCancellationEndOffset?: InputMaybe<Scalars['String']>
  bookingConfirmationByHolderAllowed?: InputMaybe<Scalars['Boolean']>
  bookingConfirmationEndOffset?: InputMaybe<Scalars['String']>
  bookingConfirmationStartOffset?: InputMaybe<Scalars['String']>
  bookingConfirmationViaLockConnectionAllowed?: InputMaybe<Scalars['Boolean']>
  /** Min value = 0 */
  bookingUnitPrice?: InputMaybe<Scalars['Int']>
  clientMutationId?: InputMaybe<Scalars['String']>
  description?: InputMaybe<Scalars['String']>
  featuredImageId?: InputMaybe<Scalars['ID']>
  holderPublic?: InputMaybe<Scalars['Boolean']>
  locationId?: InputMaybe<Scalars['ID']>
  /** Min value = 0 min, max value = 60 min */
  lockAccessEndOffsetForBooking?: InputMaybe<Scalars['Int']>
  /** Min value = -60 min, max value = 0 min */
  lockAccessStartOffsetForBooking?: InputMaybe<Scalars['Int']>
  /** Minimum value = 0, maximum value = 1000 */
  maxTimeSlotsBackwardForBooking?: InputMaybe<Scalars['Int']>
  /** Minimum value = 0, maximum value = 1000 */
  maxTimeSlotsBackwardForSharing?: InputMaybe<Scalars['Int']>
  /** Minimum value = 0, maximum value = 3000 */
  maxTimeSlotsForwardForBooking?: InputMaybe<Scalars['Int']>
  /** Minimum value = 0, maximum value = 3000 */
  maxTimeSlotsForwardForSharing?: InputMaybe<Scalars['Int']>
  /** Minimum value = 1, maximum value = 3000 */
  maxTimeSlotsPerBooking?: InputMaybe<Scalars['Int']>
  /** Minimum value = 1, maximum value = 3000 */
  maxTimeSlotsPerSharing?: InputMaybe<Scalars['Int']>
  /** Minimum value = 1, maximum value = 1000 */
  minTimeSlotsPerBooking?: InputMaybe<Scalars['Int']>
  /** Minimum value = 1, maximum value = 1000 */
  minTimeSlotsPerSharing?: InputMaybe<Scalars['Int']>
  multipleBookingsOfSameTypeAllowed?: InputMaybe<Scalars['Boolean']>
  name?: InputMaybe<Scalars['String']>
  ownerId?: InputMaybe<Scalars['ID']>
  resourceId: Scalars['ID']
  spaceplanPoint?: InputMaybe<SpaceplanPointInput>
  timeSlotLength?: InputMaybe<ResourceTimeSlotLength>
  timezone?: InputMaybe<Scalars['String']>
  /** Null value not allowed. Send an empty array to clear all translations. */
  translations?: InputMaybe<Array<UpdateResourceTranslationInput>>
  type?: InputMaybe<ResourceType>
}

export type UpdateResourcePayload = MutationPayload & {
  __typename?: 'UpdateResourcePayload'
  clientMutationId?: Maybe<Scalars['String']>
  resource: Resource
}

export type UpdateResourceProfileInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  creditDistributionType?: InputMaybe<CreditDistributionType>
  creditRenewalFrequency?: InputMaybe<CreditRenewalFrequency>
  credits?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  resourceProfileId: Scalars['ID']
}

export type UpdateResourceProfilePayload = MutationPayload & {
  __typename?: 'UpdateResourceProfilePayload'
  clientMutationId?: Maybe<Scalars['String']>
  resourceProfile: ResourceProfile
}

export type UpdateResourceProfilesInUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  resourceProfileIdsToAdd?: InputMaybe<Array<Scalars['ID']>>
  resourceProfileIdsToRemove?: InputMaybe<Array<Scalars['ID']>>
  userId: Scalars['ID']
}

export type UpdateResourceProfilesInUserPayload = MutationPayload & {
  __typename?: 'UpdateResourceProfilesInUserPayload'
  clientMutationId?: Maybe<Scalars['String']>
  user: User
}

export type UpdateResourceTranslatedValuesInput = {
  description?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
}

export type UpdateResourceTranslationInput = {
  languageId: Scalars['ID']
  values?: InputMaybe<UpdateResourceTranslatedValuesInput>
}

export type UpdateResourcesInResourceProfileInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  resourceIdsToAdd?: InputMaybe<Array<Scalars['ID']>>
  resourceIdsToRemove?: InputMaybe<Array<Scalars['ID']>>
  resourceProfileId: Scalars['ID']
}

export type UpdateResourcesInResourceProfilePayload = MutationPayload & {
  __typename?: 'UpdateResourcesInResourceProfilePayload'
  clientMutationId?: Maybe<Scalars['String']>
  resourceProfile: ResourceProfile
}

export type UpdateUserPreferencesInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  marketingConsentAccepted?: InputMaybe<Scalars['Boolean']>
}

export type UpdateUserPreferencesPayload = MutationPayload & {
  __typename?: 'UpdateUserPreferencesPayload'
  clientMutationId?: Maybe<Scalars['String']>
  viewer: User
}

export type UpdateUsersInResourceProfileInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  resourceProfileId: Scalars['ID']
  userIdsToAdd?: InputMaybe<Array<Scalars['ID']>>
  userIdsToRemove?: InputMaybe<Array<Scalars['ID']>>
}

export type UpdateUsersInResourceProfilePayload = MutationPayload & {
  __typename?: 'UpdateUsersInResourceProfilePayload'
  clientMutationId?: Maybe<Scalars['String']>
  resourceProfile: ResourceProfile
}

export type UploadFileInput = {
  clientMutationId?: InputMaybe<Scalars['String']>
  file: Scalars['Upload']
}

export type UploadFilePayload = MutationPayload & {
  __typename?: 'UploadFilePayload'
  clientMutationId?: Maybe<Scalars['String']>
  file: File
}

export type User = Node & {
  __typename?: 'User'
  accessLogs?: Maybe<UserAccessLogConnection>
  /** @deprecated Please use `node` field. This field will be removed in the next version */
  accessProfile?: Maybe<AccessProfile>
  accessProfiles?: Maybe<UserAccessProfileConnection>
  /** @deprecated Please use `node` field. This field will be removed in the next version */
  accessZone?: Maybe<AccessZone>
  accessZones?: Maybe<UserAccessZoneConnection>
  buildings?: Maybe<UserBuildingConnection>
  /** @deprecated Please use `viewerCanAddUser` field. This field will be removed in the next version */
  canAddUser?: Maybe<Scalars['Boolean']>
  /** @deprecated Please use `viewerCanCreateAccessProfile` field. This field will be removed in the next version */
  canCreateAccessProfile: Scalars['Boolean']
  /** @deprecated Please use `viewerCanCreateAccessZone` field. This field will be removed in the next version */
  canCreateAccessZone: Scalars['Boolean']
  databaseId: Scalars['Int']
  email?: Maybe<Scalars['String']>
  externalSystemFields: UserExternalSystemFieldConnection
  /** @deprecated Please use `buildings` field. This field will be removed in the next version */
  faqs?: Maybe<UserFaqConnection>
  hasAppAccount: Scalars['Boolean']
  id: Scalars['ID']
  isAccessZoneAdmin?: Maybe<Scalars['Boolean']>
  /** @deprecated Please use `viewerIsAdmin` field. This field will be removed in the next version */
  isAdmin?: Maybe<Scalars['Boolean']>
  isOrganizationAdmin?: Maybe<Scalars['Boolean']>
  isViewer: Scalars['Boolean']
  localNetworkHostCategories?: Maybe<UserLocalNetworkHostCategoryConnection>
  localNetworkHosts?: Maybe<UserLocalNetworkHostConnection>
  localNetworks?: Maybe<UserLocalNetworkConnection>
  locations: UserLocationConnection
  /** @deprecated Please use `node` field. This field will be removed in the next version */
  lock?: Maybe<Lock>
  lockDeviceFirmwares?: Maybe<UserLockDeviceFirmwareConnection>
  lockDevices?: Maybe<UserLockDeviceConnection>
  locks: UserLockConnection
  messageCategories?: Maybe<UserMessageCategoryConnection>
  name?: Maybe<Scalars['String']>
  /** @deprecated Please use `node` field. This field will be removed in the next version */
  organization?: Maybe<Organization>
  organizations?: Maybe<UserOrganizationConnection>
  receivedMessages?: Maybe<UserMessageConnection>
  /** @deprecated Please use `node` field. This field will be removed in the next version */
  resource?: Maybe<Resource>
  resourceBookings?: Maybe<UserResourceBookingConnection>
  resourceLocations?: Maybe<UserLocationConnection>
  resourceProfiles?: Maybe<UserResourceProfileConnection>
  resources?: Maybe<UserResourceConnection>
  sentMessages?: Maybe<UserMessageConnection>
  user?: Maybe<User>
  users?: Maybe<UserConnection>
  viewerCanAddMicrosoftSSOUser?: Maybe<Scalars['Boolean']>
  viewerCanAddToAccessProfile: Scalars['Boolean']
  viewerCanAddUser?: Maybe<Scalars['Boolean']>
  viewerCanCreateAccessProfile: Scalars['Boolean']
  viewerCanCreateAccessZone: Scalars['Boolean']
  viewerCanCreateLocation: Scalars['Boolean']
  viewerCanCreateOrganization?: Maybe<Scalars['Boolean']>
  viewerCanCreateResource: Scalars['Boolean']
  viewerCanCreateResourceProfile: Scalars['Boolean']
  viewerCanGenerateAccessLogsReport: Scalars['Boolean']
  viewerCanGenerateBookingsReport: Scalars['Boolean']
  viewerCanRemove: Scalars['Boolean']
  viewerCanSeeLocalNetworks?: Maybe<Scalars['Boolean']>
  viewerCanSeeOrganizations?: Maybe<Scalars['Boolean']>
  viewerCanSeeVisitorCheckInRequests: Scalars['Boolean']
  viewerCanSendMessage: Scalars['Boolean']
  viewerCanUploadFile: Scalars['Boolean']
  /** Whether this account is allowed to activate system admin mode via the X-System-Admin-Mode header. Does not reflect whether the mode is currently active for this request — see `isSuperAdmin`-derived fields for that. */
  viewerCanUseSystemAdminMode?: Maybe<Scalars['Boolean']>
  viewerDidAdd: Scalars['Boolean']
  viewerIsAdmin: Scalars['Boolean']
  viewerPreferences?: Maybe<UserPreferences>
  visitorCheckInRequests?: Maybe<UserVisitorCheckInRequestConnection>
  visitorCheckInTargets?: Maybe<UserVisitorCheckInTargetConnection>
  visitorPanels?: Maybe<UserVisitorPanelConnection>
}

export type UserAccessLogsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  from?: InputMaybe<Scalars['DateTime']>
  last?: InputMaybe<Scalars['Int']>
  locationIds?: InputMaybe<Array<Scalars['ID']>>
  lockIds?: InputMaybe<Array<Scalars['ID']>>
  success?: InputMaybe<Scalars['Boolean']>
  to?: InputMaybe<Scalars['DateTime']>
  userIds?: InputMaybe<Array<Scalars['ID']>>
}

export type UserAccessProfileArgs = {
  id: Scalars['ID']
}

export type UserAccessProfilesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  present?: InputMaybe<Scalars['Boolean']>
  viewerAccessProfileRole?: InputMaybe<RoleInAccessProfile>
}

export type UserAccessZoneArgs = {
  id: Scalars['ID']
}

export type UserAccessZonesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
}

export type UserBuildingsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type UserExternalSystemFieldsArgs = {
  accessProfileIds?: InputMaybe<Array<Scalars['ID']>>
}

export type UserFaqsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type UserIsAccessZoneAdminArgs = {
  accessZoneId: Scalars['ID']
}

export type UserIsOrganizationAdminArgs = {
  organizationId: Scalars['ID']
}

export type UserLocalNetworkHostCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
}

export type UserLocalNetworkHostsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  categoryIds?: InputMaybe<Array<Scalars['ID']>>
  first?: InputMaybe<Scalars['Int']>
  ipAddress?: InputMaybe<Scalars['String']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  networkIds?: InputMaybe<Array<Scalars['ID']>>
  organizationIds?: InputMaybe<Array<Scalars['ID']>>
  status?: InputMaybe<LocalNetworkHostStatus>
}

export type UserLocalNetworksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
}

export type UserLocationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
  viewerLocationRole?: InputMaybe<RoleInLocation>
}

export type UserLockArgs = {
  id: Scalars['ID']
}

export type UserLockDeviceFirmwaresArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
}

export type UserLockDevicesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  firmwareIds?: InputMaybe<Array<Scalars['ID']>>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  macAddress?: InputMaybe<Scalars['String']>
  name?: InputMaybe<Scalars['String']>
}

export type UserLocksArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  locationIds?: InputMaybe<Array<Scalars['ID']>>
  organizationIds?: InputMaybe<Array<Scalars['ID']>>
  search?: InputMaybe<Scalars['String']>
}

export type UserMessageCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type UserOrganizationArgs = {
  id: Scalars['ID']
}

export type UserOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
}

export type UserReceivedMessagesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type UserResourceArgs = {
  id: Scalars['ID']
}

export type UserResourceBookingsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  from?: InputMaybe<Scalars['DateTime']>
  last?: InputMaybe<Scalars['Int']>
  locationIds?: InputMaybe<Array<Scalars['ID']>>
  resourceName?: InputMaybe<Scalars['String']>
  to?: InputMaybe<Scalars['DateTime']>
  types?: InputMaybe<Array<ResourceType>>
  viewerIsHolder?: InputMaybe<Scalars['Boolean']>
}

export type UserResourceLocationsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  resourceTypes?: InputMaybe<Array<ResourceType>>
}

export type UserResourceProfilesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
}

export type UserResourcesArgs = {
  after?: InputMaybe<Scalars['String']>
  availableFrom?: InputMaybe<Scalars['DateTime']>
  availableTo?: InputMaybe<Scalars['DateTime']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  locationIds?: InputMaybe<Array<Scalars['ID']>>
  name?: InputMaybe<Scalars['String']>
  ownedByUser?: InputMaybe<Scalars['Boolean']>
  types?: InputMaybe<Array<ResourceType>>
  viewerResourceRole?: InputMaybe<RoleInResource>
}

export type UserSentMessagesArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
}

export type UserUserArgs = {
  email: Scalars['String']
}

export type UserUsersArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  nameOrEmail?: InputMaybe<Scalars['String']>
}

export type UserVisitorCheckInRequestsArgs = {
  accessCustomCredentials?: InputMaybe<Scalars['String']>
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  email?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  targetIds?: InputMaybe<Array<Scalars['ID']>>
  viewerCanAcceptOrReject?: InputMaybe<Scalars['Boolean']>
  visitorCheckInCode?: InputMaybe<Scalars['String']>
  visitorCheckInRequestStatus?: InputMaybe<VisitorCheckInRequestStatus>
  visitorPanelIds?: InputMaybe<Array<Scalars['ID']>>
}

export type UserVisitorCheckInTargetsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
}

export type UserVisitorPanelsArgs = {
  after?: InputMaybe<Scalars['String']>
  before?: InputMaybe<Scalars['String']>
  first?: InputMaybe<Scalars['Int']>
  last?: InputMaybe<Scalars['Int']>
  name?: InputMaybe<Scalars['String']>
}

export type UserAccessLogConnection = {
  __typename?: 'UserAccessLogConnection'
  edges: Array<UserAccessLogEdge>
  nodes: Array<AccessLog>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserAccessLogEdge = {
  __typename?: 'UserAccessLogEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: AccessLog
}

export type UserAccessProfileConnection = {
  __typename?: 'UserAccessProfileConnection'
  edges: Array<UserAccessProfileEdge>
  nodes: Array<AccessProfile>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserAccessProfileEdge = {
  __typename?: 'UserAccessProfileEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  externalSystemFields?: Maybe<UserExternalSystemFieldConnection>
  node: AccessProfile
  viewerCanRemoveFromUser: Scalars['Boolean']
}

export type UserAccessZoneConnection = {
  __typename?: 'UserAccessZoneConnection'
  edges: Array<UserAccessZoneEdge>
  nodes: Array<AccessZone>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserAccessZoneEdge = {
  __typename?: 'UserAccessZoneEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: AccessZone
}

export type UserBuildingConnection = {
  __typename?: 'UserBuildingConnection'
  edges: Array<UserBuildingEdge>
  nodes: Array<Building>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserBuildingEdge = {
  __typename?: 'UserBuildingEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Building
}

export type UserConnection = {
  __typename?: 'UserConnection'
  edges: Array<UserEdge>
  nodes: Array<User>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserEdge = {
  __typename?: 'UserEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: User
}

export type UserExternalSystemFieldConnection = {
  __typename?: 'UserExternalSystemFieldConnection'
  edges: Array<UserExternalSystemFieldEdge>
  nodes: Array<ExternalSystemField>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserExternalSystemFieldEdge = {
  __typename?: 'UserExternalSystemFieldEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: ExternalSystemField
  typedValue?: Maybe<ExternalSystemFieldValue>
  value?: Maybe<Scalars['String']>
}

export type UserExternalSystemFieldValueInput = {
  externalSystemFieldId: Scalars['ID']
  userId: Scalars['ID']
  value: Scalars['String']
}

export type UserFaqConnection = {
  __typename?: 'UserFAQConnection'
  edges: Array<UserFaqEdge>
  nodes: Array<Faq>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserFaqEdge = {
  __typename?: 'UserFAQEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Faq
}

export type UserLocalNetworkConnection = {
  __typename?: 'UserLocalNetworkConnection'
  edges: Array<UserLocalNetworkEdge>
  nodes: Array<LocalNetwork>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserLocalNetworkEdge = {
  __typename?: 'UserLocalNetworkEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: LocalNetwork
}

export type UserLocalNetworkHostCategoryConnection = {
  __typename?: 'UserLocalNetworkHostCategoryConnection'
  edges: Array<UserLocalNetworkHostCategoryEdge>
  nodes: Array<LocalNetworkHostCategory>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserLocalNetworkHostCategoryEdge = {
  __typename?: 'UserLocalNetworkHostCategoryEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: LocalNetworkHostCategory
}

export type UserLocalNetworkHostConnection = {
  __typename?: 'UserLocalNetworkHostConnection'
  edges: Array<UserLocalNetworkHostEdge>
  nodes: Array<LocalNetworkHost>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserLocalNetworkHostEdge = {
  __typename?: 'UserLocalNetworkHostEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: LocalNetworkHost
}

export type UserLocationConnection = {
  __typename?: 'UserLocationConnection'
  edges: Array<UserLocationEdge>
  nodes: Array<Location>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserLocationEdge = {
  __typename?: 'UserLocationEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Location
}

export type UserLockConnection = {
  __typename?: 'UserLockConnection'
  edges: Array<UserLockEdge>
  nodes: Array<Lock>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserLockDeviceConnection = {
  __typename?: 'UserLockDeviceConnection'
  edges: Array<UserLockDeviceEdge>
  nodes: Array<LockDevice>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserLockDeviceEdge = {
  __typename?: 'UserLockDeviceEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: LockDevice
}

export type UserLockDeviceFirmwareConnection = {
  __typename?: 'UserLockDeviceFirmwareConnection'
  edges: Array<UserLockDeviceFirmwareEdge>
  nodes: Array<LockDeviceFirmware>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserLockDeviceFirmwareEdge = {
  __typename?: 'UserLockDeviceFirmwareEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: LockDeviceFirmware
}

export type UserLockEdge = {
  __typename?: 'UserLockEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Lock
}

export type UserMessageCategoryConnection = {
  __typename?: 'UserMessageCategoryConnection'
  edges: Array<UserMessageCategoryEdge>
  nodes: Array<MessageCategory>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserMessageCategoryEdge = {
  __typename?: 'UserMessageCategoryEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: MessageCategory
}

export type UserMessageConnection = {
  __typename?: 'UserMessageConnection'
  edges: Array<UserMessageEdge>
  nodes: Array<Message>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserMessageEdge = {
  __typename?: 'UserMessageEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Message
}

export type UserOrganizationConnection = {
  __typename?: 'UserOrganizationConnection'
  edges: Array<UserOrganizationEdge>
  nodes: Array<Organization>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserOrganizationEdge = {
  __typename?: 'UserOrganizationEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Organization
}

export type UserPreferences = {
  __typename?: 'UserPreferences'
  marketingConsentAccepted?: Maybe<Scalars['Boolean']>
}

export type UserResourceBookingConnection = {
  __typename?: 'UserResourceBookingConnection'
  edges: Array<UserResourceBookingEdge>
  nodes: Array<ResourceBooking>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserResourceBookingEdge = {
  __typename?: 'UserResourceBookingEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: ResourceBooking
}

export type UserResourceConnection = {
  __typename?: 'UserResourceConnection'
  edges: Array<UserResourceEdge>
  nodes: Array<Resource>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserResourceEdge = {
  __typename?: 'UserResourceEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: Resource
}

export type UserResourceProfileConnection = {
  __typename?: 'UserResourceProfileConnection'
  edges: Array<UserResourceProfileEdge>
  nodes: Array<ResourceProfile>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserResourceProfileEdge = {
  __typename?: 'UserResourceProfileEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: ResourceProfile
}

export type UserVisitorCheckInRequestConnection = {
  __typename?: 'UserVisitorCheckInRequestConnection'
  edges: Array<UserVisitorCheckInRequestEdge>
  nodes: Array<VisitorCheckInRequest>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserVisitorCheckInRequestEdge = {
  __typename?: 'UserVisitorCheckInRequestEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: VisitorCheckInRequest
}

export type UserVisitorCheckInTargetConnection = {
  __typename?: 'UserVisitorCheckInTargetConnection'
  edges: Array<UserVisitorCheckInTargetEdge>
  nodes: Array<VisitorCheckInTarget>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserVisitorCheckInTargetEdge = {
  __typename?: 'UserVisitorCheckInTargetEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: VisitorCheckInTarget
}

export type UserVisitorPanelConnection = {
  __typename?: 'UserVisitorPanelConnection'
  edges: Array<UserVisitorPanelEdge>
  nodes: Array<VisitorPanel>
  pageInfo: PageInfo
  totalCount: Scalars['Int']
}

export type UserVisitorPanelEdge = {
  __typename?: 'UserVisitorPanelEdge'
  /** Used in `before` and `after` args */
  cursor: Scalars['String']
  node: VisitorPanel
}

export type VisitorCheckInBenefit = FreeTimeVisitorCheckInBenefit

export enum VisitorCheckInBenefitType {
  FreeTime = 'FREE_TIME',
}

export type VisitorCheckInRequest = Node & {
  __typename?: 'VisitorCheckInRequest'
  accessCustomCredentials?: Maybe<Scalars['String']>
  /**
   * Available only when status = ACCEPTED and the visit is not paid
   * @deprecated Please use `start` and `end` fields. This field will be removed in the next version
   */
  accessRange?: Maybe<DateTimeRange>
  availableBenefits?: Maybe<Array<VisitorCheckInBenefit>>
  billing?: Maybe<Billing>
  createdAt: Scalars['DateTime']
  /** @deprecated Please use `visitorEmail` field. This field will be removed in the next version */
  email: Scalars['String']
  end?: Maybe<Scalars['DateTime']>
  entries: Array<VisitorCheckInRequestFormEntry>
  /** Time left to exit after the paid or granted time ends, in minutes. */
  exitGracePeriod: Scalars['Int']
  exitedAt?: Maybe<Scalars['DateTime']>
  grantedBenefits?: Maybe<Array<VisitorCheckInBenefit>>
  id: Scalars['ID']
  start?: Maybe<Scalars['DateTime']>
  status: VisitorCheckInRequestStatus
  target: VisitorCheckInTarget
  timezone: Scalars['String']
  viewerCanAccept: Scalars['Boolean']
  viewerCanReject: Scalars['Boolean']
  visitorCheckInCode?: Maybe<Scalars['String']>
  visitorEmail?: Maybe<Scalars['String']>
}

export type VisitorCheckInRequestCreatedAtArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type VisitorCheckInRequestEndArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type VisitorCheckInRequestExitedAtArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type VisitorCheckInRequestStartArgs = {
  local?: InputMaybe<Scalars['Boolean']>
}

export type VisitorCheckInRequestFormEntry = {
  __typename?: 'VisitorCheckInRequestFormEntry'
  field: VisitorCheckInTargetFormField
  value: Scalars['Primitive']
}

export enum VisitorCheckInRequestStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
}

export type VisitorCheckInTarget = Node & {
  __typename?: 'VisitorCheckInTarget'
  formFields: Array<VisitorCheckInTargetFormField>
  id: Scalars['ID']
  logoUrl: Scalars['URL']
  name: Scalars['String']
  visitorPanel: VisitorPanel
}

export type VisitorCheckInTargetFormField = Node & {
  __typename?: 'VisitorCheckInTargetFormField'
  id: Scalars['ID']
  label: Scalars['String']
  type: VisitorCheckInTargetFormFieldType
}

export enum VisitorCheckInTargetFormFieldType {
  Checkbox = 'CHECKBOX',
  Email = 'EMAIL',
  PhoneNumber = 'PHONE_NUMBER',
  PlPesel = 'PL_PESEL',
  Text = 'TEXT',
}

export type VisitorPanel = Node & {
  __typename?: 'VisitorPanel'
  id: Scalars['ID']
  name: Scalars['String']
}
